const ro = {
  common: {
    search: 'Căutare',
    tb: 'TB',
    active: 'Activ',
    inactive: 'Inactiv',
    sort_by: 'Sortează după',
    edit: 'Editează',
    delete: 'Șterge',
    save: 'Salvează modificările',
    cancel: 'Anulați',
    all: 'Toate',
    save_success: 'Datele au fost salvate cu succes',
    description: 'Descriere',
    optional: 'Optional',
    level: 'Nivel',
    add: 'Adăugați ',
    institution: 'Instituție',
    role: 'Rol',
    add_option: 'Adaugă opțiune',
    finished: 'Finalizat',
    today: 'Astăzi',
    yesterday: 'Ieri',
    see_details: 'Vezi detalii',
    view_more: 'Vezi mai mult',
    confirm: 'Confirmă',
    select_from_list: 'Selectează din listă',
    date: 'Data',
    department: 'Departament',
    by_department: 'După Departament',
    type: 'Tip',
    product: 'Produs',
    group: 'Grupa',
    medicine: 'Medicamente',
    quantity: 'Cantitate',
    unit: 'UM',
    producer: 'Producător',
    contract_number: 'Nr. Contract',
    pieces: 'buc.',
    age: 'Vârstă',
    years: 'ani',
    view: 'Vizualizează',
    case: 'Caz',
    code: 'Cod',
    commercial_name: 'Denumirea comună internațională',
    international_name: 'Denumirea Internațională',
    commercial_naming: 'Denumire Comercială',
    active_component: 'Componenta Activă',
    production_date: 'Data producerii',
    expiration_date: 'Data expirării',
    info: 'Info',
    close: 'Închide',
    yes: 'Da',
    no: 'Nu',
    see_all_list: 'Vezi lista completă',
    phone: 'Telefon',
    comment: 'Comentariu',
    leave_comment: 'Lasă un comentariu',
    total: 'Total',
    invoice: 'Factura',
    invoice_number: 'Nr. Facturii',
    phone_label: 'Telefon',
    or: 'sau',
    accept: 'Acceptă',
    decline: 'Declină',
    sime_code: 'Cod SIME',
    action: 'Acțiune',
    back: 'Înapoi',
    import: 'Importați',
    export: 'Exportați',
    upload_document: 'Încărcați documentul',
    by_company: 'După Companii',
    send: 'Transmite',
    transport: 'Transport',
    sent: 'Trimis',
    instructions: 'Instrucțiuni',
    enter_text: 'Introduceți textul',
    user: 'Utilizator',
    default: 'Implicit',
    delete_description: 'Această acțiune este ireversibilă',
    save_description: 'Această acțiune va salva modificările.',
    success_delete: 'Datele au fost șterse cu succes',
    doctor: 'Medic',
    doctors_2_to_4: 'Medici',
    doctors: 'Medici',
    details: 'Detalii',
    country: 'Țara',
    filters: 'Filtre',
    server_error: 'Ceva nu a mers bine.',
    tarv_code: 'Cod TARV',
    tarv_code_update_error: 'Codul TARV nu a putut fi actualizat.',
    citizenship: 'Cetățenie',
    person: 'Persoană',
    min_one_quantity: 'Cantitatea minimă este 1',
    ong: 'ONG',
    laboratory: 'Laborator',
    hour: 'Ora',
    treatment: 'Tratament',
    medical_institution: 'Instituție Medicală',
    columns: 'Coloane',
    order: 'Ordinea',
    comments: 'Comentarii',
    access: 'Accesează',
    select: 'Selectează',
    patient: 'Pacient',
    cost_per_unit_with_tva: 'Costul per unitate',
    total_tva: 'Suma totală cu TVA',
    measure_unit: 'Unitatea de măsură',
    tva: 'TVA',
    months: 'luni',
    pharmaceutics: 'Parafarmaceutice',
    medicines: 'Medicamente',
    price_unit: 'Preț Unitate (MDL)',
    update: 'Actualizează',
    delivered_quantity: 'Cantitate livrată',
    outstanding_quantity: 'Cantitate rămasă',
    testrap_code: 'Cod testrap',
    remove: 'Șterge',
    remove_assigned_medic: 'Șterge {{name}}, medicul asignat',
    belongs: 'Aparține'
  },
  auth: {
    logout: 'Ieși din cont',
    login_title: 'Autentificare',
    login_subtitle:
      'Introduceți detaliile dvs pentru a vă loga sau creați un cont nou de Administrator cu MPass.',
    remember_me: 'Păstrează-mă autentificat',
    reset_password: 'Reseteaza parola',
    mpass_auth: 'Autentificare cu MPass',
    forgot_password_title: 'Ați uitat parola?',
    forgot_password_subtitle:
      'Nu vă faceți griji, vă vom trimite instrucțiunile de resetare.',
    send_instructions: 'Trimiteți instrucțiunile de resetare',
    remember_password: 'V-ați amintit parola?',
    return_to_auth: 'Reveniți la autentificare',
    check_email: 'Verificați e-mailul',
    check_email_subtitle:
      'Am trimis instrucțiuni de confirmare a contului pe adresa dvs. de e-mail.',
    check_email_description:
      'Nu ai primit e-mailul? Verificați folderul de spam sau',
    try_again: ' încercați din nou',
    create_new_password: 'Creați o parolă nouă',
    create_new_password_subtitle:
      'Vă rugăm să introduceți parola nouă și să vă asigurați că alegeți o parolă puternică.',
    login_error: 'Eroare: nume de utilizator sau parolă incorectă.',
    not_have_account: 'Nu aveți cont ?',
    signup: 'Înregistrați-vă',
    create_new_account: 'Creați cont nou',
    signup_description: 'Introduceți detaliile dvs pentru a crea un cont nou',
    signup_success: 'Contul a fost creat cu succes',
    email_change_success: 'Email schimbat cu succes',
    email_change_error: 'Adresă de email invalidă',
    resend_email_success: 'Email-ul a fost trimis cu succes',
    confirm_account_success: 'Contul a fost confirmat cu succes',
    confirm_account_error: 'A intervenit o eroare la confirmarea contului',
    confirm_otp_subtitle:
      'Am trimis codul de verificare pe adresa dvs de email. Te rugăm să verifici inboxul și să introduci codul de verificare mai jos pentru a confirma adresa de email.',
    verification_code: 'Codul de verificare',
    resend_code: 'Retrimite codul',
    reset_password_request_success:
      'Cererea de resetare a parolei a fost trimisă cu succes',
    passwordRegex: {
      password: 'Parola trebuie să aibă între',
      characters: 'caractere',
      lowercase: 'Cel puțin o literă mică',
      uppercase: 'Cel puțin o literă mare',
      number: 'Cel puțin o cifră',
      special: 'Cel puțin un caracter special',
      weak: 'Slabă',
      medium: 'Medie',
      strong: 'Puternică',
      level: 'Nivel',
      levelReq: 'Parola trebuie să conțină'
    },
    reset_password_success: 'Parola a fost resetată cu succes',
    reset_password_success_subTitle:
      'Parola a fost resetată cu succes, încercați să vă conectați cu noua parolă.',
    wrong_otp: 'Codul OTP nu este valid'
  },
  menu: {
    organizational_structure: 'Structură organizatorică',
    other_institutions: 'Alte instituții',
    users: 'Utilizatori',
    reports: 'Rapoarte',
    classifiers: 'Clasificatoare',
    notification_templates: 'Șabloane de notificări',
    templates: 'Șabloane',
    roles: 'Roluri',
    logs: 'Activitate',
    settings: 'Setări',
    appointments: 'Programări',
    notifications: 'Notificări',
    treatments: 'Tratamente',
    tests_results: 'Rezultate test',
    stock: 'Stoc',
    analysis: 'Analize',
    cases: 'Cazuri epidemiologice',
    visits: 'Vizite',
    transfers: 'Solicitări transfer',
    liberations: 'Eliberări',
    reports_administration: 'Administrare Rapoarte',
    persons: 'Persoane',
    persons_management: 'Persoane și pacienți',
    persons_from_screening: 'Persoane din screening',
    support_investigation: 'Suport Investigații',
    recipes: 'Rețete',
    medicines_register: 'Registru Med-Cons',
    consumable_medicaments: 'Medicamente-Consumabile',
    stock_institution: 'Stocul Instituției',
    issuance: 'Eliberări',
    ong_support: 'Suport ONG',
    riskGroups: 'Grupuri de risc',
    localStock: 'Stoc Specialist',
    tests: 'Probe',
    investigations: 'Investigații',
    platform_settings: 'Configurare sistem',
    questionnaires: 'Chestionare',
    investigation_templates: 'Template-uri investigații',
    systemSettings: 'Configurare sistem',
    patients: 'Pacienți',
    equipments: 'Echipamente',
    prescriptions: 'Rețete',
    prescription: 'Rețeta',
    stock_groups: 'Grupuri de stoc',
    funding_source: 'Sursa de finanțare',
    active_substances: 'Substanțe active',
    device_types: 'Tipuri de dispozitive',
    laboratory_classifiers: 'Clasificatoare laborator',
    risk_groups: 'Grupuri de risc',
    treatment_types_classifier: 'Clasificatoare tratamente',
    cuatm: 'Clasificator CUATM'
  },
  form: {
    required: 'Acest câmp este obligatoriu',
    email: 'Email',
    email_address: 'Adresa de email',
    email_error: 'Introduceți un email valid',
    email_placeholder: 'Introduceți adresa dvs de e-mail',
    password: 'Parola',
    repeat_password: 'Repetă parola',
    confirm_password_error: 'Parolele nu coincid',
    last_name: 'Nume',
    first_name: 'Prenume',
    birth_date: 'Data nașterii',
    gender: 'Genul',
    male: 'Masculin',
    female: 'Feminin',
    unknown: 'Neidentificat',
    medical_institution: 'Instituția Medicală',
    idnp: 'IDNP',
    contact_number: 'Telefon de contact',
    status: 'Statut',
    address: 'Adresa de trai',
    idnp_error: 'Introduceți IDNP valid',
    city: 'Oraș',
    street: 'Strada',
    apartment_number: 'Apartament',
    building: 'Număr casă',
    notes: 'Notițe',
    fiscal_code_error: 'Introduceți cod fiscal valid',
    social_status: 'Statut social',
    current_password: 'Parola actuală',
    new_password: 'Parola nouă',
    confirm_password: 'Repetă parola',
    change_password: 'Schimba parola',
    contact_date: 'Data de contact',
    include_anonymous: 'Include persoane anonime',
    not_include_anonymous: 'Ascunde persoane anonime',
    testrapCode: 'Codul TESTRAP',
    add_prison: 'Adaugă date',
    progress: 'Progresul'
  },
  notifications: {
    title: 'Notificări',
    read_all: 'Marchează ca citite',
    see_all: 'Vezi toate notificările',
    notifications_type: 'Tip notificări',
    empty_text: 'Nu sunt notificări',
    today: 'Astăzi',
    yesterday: 'Ieri',
    minutes: 'minute',
    minute: 'minută',
    now: 'Acum',
    ago: 'in urmă',
    hour: 'oră',
    hours: 'ore',
    zero_notifications: 'Nu aveți nici o notificare',
    search_placeholder: 'Căutare notificări',
    from_date: 'De la data',
    to_date: 'Până la data',
    view_details: 'Vezi detalii'
  },
  pageHeader: {
    main_page: 'Principală'
  },
  organizational_structure: {
    add_button: 'Adaugă o instituție medicală',
    tree: 'Arbore',
    organioram: 'Structură organizatorică',
    profile: 'Profilul instituției',
    structure: 'Structura organizatorică',
    structure_logic: 'Structura logică',
    equipment: 'Echipament',
    idno: 'IDNO',
    idno_error: 'Introduceți IDNO valid din 13 cifre',
    name: 'Denumirea Instituției',
    type: 'Tip',
    phone: 'Telefon de contact',
    fax: 'Fax',
    email: 'Email',
    cuatm_code: 'Codul CUATM',
    cuatm_code_placeholder: 'Introduceți codul',
    city: 'Localitate',
    street: 'Strada',
    region: 'Regiune',
    services: 'Servicii prestate de către instituție',
    lab: 'Investigații',
    other: 'Altele',
    institutions: 'Instituții',
    phone_error:
      'Numărul de telefon trebuie să înceapă cu +373 şi să conţină 8 cifre',
    institution_classification: 'Clasificarea instituției conform apartenenței',
    caseDeclarerInstitutionId: 'Reprezintă instituția',
    declaresCases: 'Declară Cazuri',
    tracksCases: 'Face evidența cazurilor',
    isWithoutCode: 'Instituție fără cod',
    equipment_tab: {
      search_placeholder: 'Căutare echipament',
      add_new_equipment: 'Adăugați un echipament nou',
      add_equipment: 'Adaugă echipament',
      unique_number: 'Cod unic',
      name: 'Denumire',
      select_equipment: 'Selectează Echipament',
      sort_code_asc: 'Cod (A-Z)',
      sort_code_desc: 'Cod (Z-A)',
      sort_name_asc: 'Nume (A-Z)',
      sort_name_desc: 'Nume (Z-A)'
    },
    department_tab: {
      add_button: 'Adăugați un departament nou',
      modal_title: 'Adăugați un departament',
      modal_title_edit: 'Editați departamentul',
      title: 'Titlu',
      title_placeholder: 'Titlu departament',
      search_placeholder: 'Căută',
      select_from_list: 'Selectează din listă',
      add_users: 'Adăugați utilizatori',
      department_group: 'Grupa de departament'
    },
    delete_institution_success: 'Instituția a fost ștearsă cu succes',
    add_success: 'Instituția a fost adăugată cu succes',
    edit_success: 'Instituția a fost modificată cu succes',
    institution_code: 'Codul instituției',
    monitoring_institutions_card: 'Localități monitorizate',
    add_locality: 'Adaugă localitate',
    medical_assistance_types: 'Servicii prestate',
    roles: 'Rolurile pe care le deține',
    institution_type: 'Tipul instituției',
    laboratory_not_selected:
      'Vă rugăm să selectați un laborator în fila Generale pentru a vedea investigațiile disponibile.'
  },
  settings: {
    security_settings: 'Setări de securitate',
    profile_settings: 'Setări de profil',
    current_password: 'Parola actuală',
    current_password_placeholder: 'Introduceți parola',
    new_password: 'Crează parola nouă',
    new_password_placeholder: 'Introduceți parola nouă',
    repeat_password: 'Repetați parola nouă',
    repeat_password_placeholder: 'Reintroduceți aceeași parolă',
    change_data: 'Schimbă datele',
    password_success_message: 'Parola a fost schimbată cu succes',
    profile_success_message: 'Datele au fost salvate cu succes',
    profile_default_language: 'Limba sistemului'
  },
  notification_templates: {
    create: 'Creați un șablon nou',
    name: 'Titlu șablon',
    notification_title: 'Titlu notificare',
    content: 'Conținut',
    create_new_template: 'Creează un șablon',
    notification: 'Notificare',
    type: 'Tip notificare',
    preview: 'Previzualizare notificare',
    preview_type: ' Rezultat test',
    preview_title: 'Rezultate de laborator',
    preview_content:
      'Rezultatele analizelor pentru pacientul [X] sunt disponibile. Te rugăm să le revizuiește.',
    preview_time: '2 ore în urmă',
    edit_template: 'Editează șablon',
    event: 'Eveniment',
    chanel: 'Canal',
    roles: 'Roluri',
    email: 'Email',
    push_notification: 'Push notification',
    all: 'Toate',
    search_placeholder: 'Căutare șablon de notificări',
    success_delete: 'Șablonul a fost șters cu succes',
    error_ru: 'Lipsește conținut în rusă',
    name_asc: 'Nume (A-Z)',
    name_desc: 'Nume (Z-A)',
    event_asc: 'Eveniment (A-Z)',
    event_desc: 'Eveniment (Z-A)',
    action_url: 'Link',
    placeholders: 'Placeholder-uri'
  },
  roles: {
    add_new_role: 'Adăugați un rol nou',
    system_roles: 'Roluri de sistem',
    custom_roles: 'Roluri personalizate',
    title_role: 'Titlu Rol',
    permissions: 'Permisiuni',
    access_level: 'Nivel de acces',
    role_description: 'Descriere rol',
    general_permissions: 'Permisiuni',
    edit_role: 'Modificarea rolului',
    system_roles_empty: 'Nu există nici un rol de sistem.',
    custom_roles_empty: 'Nu există nici un rol personalizat.',
    patient: 'Pacient',
    medical_institution_user: 'Utilizator instituție medicală',
    medical_institution_admin: 'Administratorul șef instituție medicală',
    central_laboratory_user: 'Utilizator laborator central',
    private_laboratory_user: 'Utilizator laborator privat',
    national_stock_user: 'Utilizator stoc național',
    medical_institution_stock_user: 'Utilizator stoc instituție medicală',
    pharmacy_user: 'Utilizator farmacie',
    epidemiologist_user: 'Utilizator epidemiolog',
    national_admin_user: 'Utilizator administrator național',
    medical_institution_administrator_user:
      'Utilizator administrator instituție medical',
    name_asc: 'Titlu (A-Z)',
    name_desc: 'Titlu (Z-A)',
    access_asc: 'Nivel de access (cresc.)',
    access_desc: 'Nivel de access (descresc.)',
    institutions: 'Instituții atribuite acestui rol',
    delete_confirm_title: 'Sigur doriți să ștergeți acest rol ?',
    confirm: 'Confirmați',
    save: 'Salvați modificările',
    permission_level: 'Nivel de permisiune',
    select_institutions: 'Selectați instituții',
    select_ong: 'Selectați ONG-uri'
  },

  users: {
    create_new_user: 'Creează un utilizator nou',
    last_access_time: 'Data ultimei accesări',
    general_info: 'Informații generale',
    system_roles: 'Roluri în sistem',
    assignee_role: 'Asignează un rol',
    no_roles: 'Acest utilizator nu are nici un rol asignat.',
    assignee_a_role: 'Atribuiți un rol',
    select_institution: 'Selectează Instituția',
    system_role: 'Rol în sistem',
    delete_user_title: 'Sigur doriți să ștergeți acest utilizator ?',
    cancel: 'Anulați',
    name_asc: 'Nume (A-Z)',
    name_desc: 'Nume (Z-A)',
    birth_date_asc: 'Data nașterii (cresc.)',
    birth_date_desc: 'Data nașterii (descresc.)',
    select_institution_type: 'Selectează tipul de instituție',
    authentication_type_email: 'Prin email',
    authentication_type_mpass: 'Prin Mpass',
    authentication_type: 'Tip de autentificare'
  },
  activity: {
    activity: 'Activitate',
    search_placeholder: 'Căutare după nume',
    changedInfoText: 'a modificat informația despre pacientul'
  },
  classifiers: {
    classifiers: 'Clasificatoare',
    search_placeholder: 'Căutare clasificator',
    title: 'Titlu',
    description: 'Descriere',
    category: 'Categorie',
    elements: 'Elemente din clasificator',
    general: 'General',
    delete: 'Sigur doriți să ștergeți acest element?',
    hasKey: 'Afișează numărul de ordine',
    result_positivity: 'Pozitivitate rezultat',
    positivity_positive: 'Pozitiv',
    positivity_negative: 'Negativ',
    positivity_others: 'Altele',
    system_key: 'Cheie sistem',
    system_key_held_by: 'Setată pe: {{name}}',
    system_key_move: 'Mută cheia de pe {{name}}?',
    opportunistic_diseases: 'Boli oportuniste (ICD-10-AM)',
    opportunistic_disease_toggle: 'Boală oportunistă (fișa 058-1/e, 56)',
    only_marked: 'Doar cele marcate'
  },
  appointments: {
    date_and_time: 'Data / Ora',
    location: 'Locația',
    doctor: 'Medic'
  },
  treatments: {
    id: 'ID',
    type: 'Tip',
    start: 'Începutul',
    end: 'Finalizarea',
    status: 'Statut',
    institution: 'Instituția',
    treatments_details: 'Detalii tratament',
    treatment_type: 'Tipul tratamentului',
    medication_name: 'Denumirea preparatului',
    medication_dose: 'Dozajul',
    medication_type: 'Tipul de administrare',
    medication_frequency: 'Frecvența utilizării',
    treatment_start_date: 'Începerea tratamentului',
    treatment_end_date: 'Finalizarea tratamentului',
    prescribed_by: 'Prescris de',
    report_reactions: 'Raportează reacții adverse',
    reactions: 'Reacții adverse',
    report_reactions_desc: 'Descrie mai multe detalii despre reacțiile adverse',
    report_reactions_placeholder: 'Informații despre starea de sănătate',
    arv_medication: 'Medicamente ARV',
    opportunistic_diseases: 'Boli oportuniste/Boli Concomitente',
    concomitant_diseases: 'Boli Concomitente',
    tar_treatment: 'Terapia antiretrovirală (ARV)',
    event_medication: 'Medicamente implicate',
    treatment_start_date_asc: 'Începerea tratamentului (A - Z)',
    treatment_start_date_desc: 'Începerea tratamentului (Z - A)',
    treatment_end_date_asc: 'Finalizarea tratamentului (A - Z)',
    treatment_end_date_desc: 'Finalizarea tratamentului (Z - A)',
    treatment_type_asc: 'Tipul tratamentului (A - Z)',
    treatment_type_desc: 'Tipul tratamentului  (Z - A)',
    new: 'Activ',
    inProgress: 'În derulare',
    completed: 'Finalizat',
    cancelled: 'Suspendat',
    cancel_treatment: 'Întrerupeți tratamentul',
    finish_treatment: 'Finalizați tratamentul',
    person_who_created_the_treatment: 'Persoana care a creat tratamentul:',
    cancel_treatment_title: 'Doriți să întrerupeți tratamentul?',
    event_date: 'Data evenimentului',
    cancel_reason: 'Motivul întreruperii',
    next_consultation_date: 'Data următoarei consultații',
    diagnostic_details: 'Detalii diagnostic',
    diagnostic_date: 'Data stabilirii diagnosticului',
    urgent_treatment: 'Tratament urgent',
    confirm_delete_adverse_reactions: 'Sigur doriți aceasta reacție ?',
    regiment_type: 'Tipul schemei de tratament'
  },
  tests_results: {
    type: 'Tipul testului',
    result: 'Rezultat',
    collection_date: 'Data recoltării',
    test_date: 'Data test',
    result_date: 'Data rezultat',
    positive: 'Pozitiv',
    inconclusive: 'Inconcludent',
    negative: 'Negativ',
    registration_number: 'Nr. de inregistrare',
    save_test_result: 'Salvați rezultat',
    test_hiv_1_hiv_2: 'Rezultat TRD HIV 1/2',
    test_hiv_1: 'HIV 1',
    test_hiv_2: 'HIV 2',
    responsible_person_name: 'Persoana responsabilă de testare',
    medic_name: 'Medicul/consilierul care a inițiat testul',
    testing_at_asc: 'Instituție (A - Z)',
    testing_at_desc: 'Instituție (Z - A)',
    status_asc: 'Statut (A - Z)',
    status_desc: 'Statut (Z - A)',
    test_type_asc: 'Tipul testului (A - Z)',
    test_type_desc: 'Tipul testului (Z - A)',
    test_date_asc: 'Data testului (A - Z)',
    test_date_desc: 'Data testului (Z - A)',
    statuses: {
      undefined: 'Nedefinit',
      new: 'Nou',
      started: 'În lucru',
      approved: 'Aprobat',
      submittedToValidation: 'Trimis la validare',
      rejected: 'Respins'
    },
    validated_by: 'Validat de',
    tested_by_initial: 'Medic testare inițială',
    created_by: 'Creat de',
    received_by: 'Recepționat de',
    approved: 'Aprobat',
    result_value_option: 'Opțiune valoare rezultat',
    device_result: 'Rezultat dispozitiv',
    device_test_type: 'Test dispozitiv',
    cartridge_serial_number: 'Nr. serie cartuș',
    reagent_lot_id: 'Lot reagent',
    cartridge_expiration_date: 'Data expirare cartuș',
    no_results: 'Nu există rezultate',
    created_institution: 'Instituția care a creat',
    validation_institution: 'Instituția de validare',
    edit_result: 'Editează rezultatul',
    confirm_result: 'Confirmarea rezultatului',
    confirm_result_current: 'Confirm rezultatul introdus',
    confirm_result_different: 'Introduc alt rezultat',
    result_updated: 'Rezultatul a fost actualizat cu succes',
    edit_approved_result_warning:
      'Rezultatul a fost deja transmis medicului solicitant. Modificarea va fi înregistrată.'
  },
  reports: {
    search_by_report_title: 'Căutare după titlul raportului',
    report_type: 'Tip de Rapoarte',
    report_title: 'Titlul raportului',
    clinical_administrative_activity_report:
      'Raport Anual de Activitate Clinică și Administrativă',
    export_report: 'Exportați raport',
    contract_quantity: 'Cantitate contractata',
    contract_value: 'Valoare contractata',
    amount_purchase: 'Cantittate achizitionata',
    contract_date: 'Data contractului',
    by_organizational_structure: 'După Structura Organizatorică',
    generate_report: 'Generați raport'
  },
  other_institutions: {
    address: 'Adresă',
    contact_data: 'Date de contact',
    fiscal_code: 'Cod fiscal',
    country: 'Țara',
    number: 'Nr.',
    other_institutions_created_success: 'Instituția a fost creată cu succes',
    add_institution: 'Adaugă o instituție nouă',
    delete_institution: 'Ștergeți instituția',
    delete_institution_success: 'Instituția a fost ștearsă cu succes'
  },
  stock: {
    applications: 'Cereri',
    inputs: 'Intrări',
    returns: 'Returnări',
    settlement: 'Decontare',
    medicines_includes: 'Medicamente incluse',
    add_manual_input: 'Adaugă o intrare manuală',
    out_of_stock: 'Medicamentul este epuizat',
    expired: 'Medicamentul a expirat',
    purchase_documents: 'Documente de achiziție',
    input_invoice: 'Factură',
    invoice_date: 'Data facturii',
    entry_management_date: 'Data intrării în gestiune',
    accompanying_invoice: 'Nr. Factură',
    provider: 'Furnizor',
    internal_management_number: 'Nr. Intern / Gestiune',
    management: 'Gestiunea',
    delegate: 'Delegatul',
    invoiced_value: 'Valoarea facturată',
    car_number: 'Numărul mașinii',
    stocks: 'Stocuri',
    stock_entry: 'Intrare de stoc',
    confirm_stock_adding: 'Confirmă adăugarea în stoc',
    add_medicine: 'Adaugă medicament',
    search_placeholder: 'Căutare după denumire sau cod',
    received: 'Receptionat',
    received_new_stock: 'Ai primit o nouă intrare de stoc.',
    entry_date_from: 'Intrarea de la',
    entry_date_to: 'Până la',
    filled_requests: 'Cereri inregistrate',
    production_from: 'Producția de la',
    production_to: 'Până la',
    expiration_from: 'Expiră de la',
    expiration_to: 'Până la',
    return_reason: 'Motivul returnarii',
    edit_reason: 'Motivul editării',
    issuance_allowed: 'Eliberare permisa?',
    consumable_settings: 'Setari consumabile',
    delete_group_title: 'Ștergeți acest grup de stoc?',
    delete_group_success: 'Grupul a fost șters cu succes',
    create_group: 'Creați un grup nou',
    create_group_success: 'Grupul a fost creat cu succes',
    status_valid: 'Valid',
    status_expired: 'Expirat',
    status_expireInAWhile: 'Expiră în curand',
    notify_quantity: 'Notificare la cantitate',
    services: 'Costuri adiționale',
    services_products: 'Costuri adiționale + Produs',
    services_add: 'Adaugă costuri adiționale',
    service_name: 'Denumirea serviciului',
    service_name_select: 'Selectați denumirea serviciului',
    stock_category: 'Categorie de stoc',
    service_price: 'Prețul serviciului'
  },
  stock_applications: {
    request_medicine: 'Solicită medicamente',
    request_date: 'Data Creării',
    refusal_date: 'Data Refuzului',
    accepted_date: 'Data Acceptării',
    accept: 'Acceptare cerere',
    view: 'Vizualizare cerere',
    approve_application: 'Aprobă solicitarea',
    add_medicine: 'Adaugă medicament',
    select_medicine: 'Selectează medicament',
    cause: 'Motivul/Cerințe speciale',
    cause_placeholder:
      'Descriere succintă referitor motivului cererii sau a altor cerințe speciale ',
    documents: 'Documente relevante',
    upload_title: 'Adăugați document aici sau selectați',
    upload_description: 'PDF, DOC sau Excel (max. 5MB)',
    medicine_application: 'Cerere de medicamente',
    stock_application: 'Cerere de stoc',
    number: 'Nr.',
    juridic_person: 'Persoană juridică',
    consumables: 'Consumabile',
    confirmed: 'Livrată',
    sent: 'Livrat',
    new: 'Draft',
    waiting: 'În așteptare',
    rejected: 'Refuzată',
    accepted: 'Acceptată',
    accept_inquiry: 'Acceptați cerere',
    successfully_accepted: 'Cererea a fost acceptată cu succes',
    send_inquiry: 'Trimite cerere',
    successfully_sent: 'Cererea a fost trimisă cu succes',
    approved: 'Aprobata',
    received: 'Recepționat',
    canceled: 'Anulat',
    modifiedAndAccepted: 'Modificată/Acceptată',
    recovered: 'Restabilit',
    create_new_application: 'Creați o cerere nouă',
    edit_application: 'Editați cererea',
    save_as_draft: 'Salvați ca schiță',
    send: 'Trimiteți',
    inquiry_created_success: 'Cererea a fost creată cu succes',
    inquiry_sent_success: 'Cererea a fost trimisă cu succes',
    in_stock: 'În stoc',
    medicine_and_consumables: 'Medicamente și consumabile',
    needed_quantity: 'Cantitate solicitată',
    modified_quantity: 'Cantitate modificată',
    approved_quantity: 'Cantitate aprobată',
    inquire_sent: 'Cererea a fost trimisă',
    inquiry_number: 'Cerere de stoc',
    see_application_details: 'Vezi detalii intrare',
    print: 'Printați',
    entry_date: 'Data intrării',
    initiated_by: 'Persoana care a inițiat cererea',
    refused_by: 'Persoana care a refuzat cererea',
    accepted_by: 'Persoana care a acceptat cererea',
    requested_to: 'Către Instituția Medicală',
    institution_stock: 'Stocul Instituției',
    local_stock: 'Stocul local',
    issuance_based_on_inquire: 'Eliberare în baza cererii',
    uploaded_documents: 'Documente',
    release: 'Eliberați',
    confirm: 'Confirmați',
    medicine_requested: 'Consumabile solicitate',
    medicine_to_release: 'Consumabile către eliberare',
    series: 'Seria',
    successfully_issued: 'Medicamentele au fost eliberate cu succes',
    submit_medicine_for: 'Selectați cel putin un medicament pentru {{name}}',
    select_at_least_one_medicine: 'Selectați cel puțin un medicament',
    beneficiary: 'Beneficiar',
    rejected_success: 'Cererea a fost respinsă cu succes',
    applicant: 'Solicitant',
    inStoc: 'Stoc Instituție',
    liberation_document: 'Document de eliberare',
    requested_medicine: 'Medicamente și consumabile solicitate',
    medicine_consumables_to_release:
      'Medicamente și consumabile către eliberare',
    to_release: 'Spre eliberare',
    stock_issuance_create: 'Cerere de eliberare',
    confirm_send_title: 'Trimiteți cererea?',
    confirm_send_desc: 'Sigur vrei să trimiți cererea?',
    invoice_date: 'Data Cererii',
    settlement_sent: 'Documentul de casare a fost trimis'
  },
  stock_administration: {
    juridic_person: 'Persoană juridică',
    add_new_input: 'Adaugă o intrare nouă',
    entry_date: 'Data intrării',
    total_stock: 'Total in stoc',
    type: 'Tip',
    select_transport: 'Transportator',
    invoice_number: 'Numărul facturii',
    release_date: 'Data eliberării',
    pickup_date: 'Data preluare',
    delivery_date: 'Data livrare',
    way_bill: 'Aviz de însoțire',
    institution_code: 'Codul instituției',
    register_transport: 'Înregistrează transportator',
    manual_entry: 'Inregistrare factura de intrare',
    price_unit: 'Preț unitar (MDL)',
    price_total: 'Preț total (MDL)',
    manual_entry_returns: 'Inregistrare factură de expediere',
    manual_entry_settlements: 'Act de contare',
    act_number: 'Numărul actului',
    elaboration_date: 'Data elaborării',
    record_incoming_invoice: 'Înregistrare factură de intrare',
    takeover_date: 'Data preluării',
    accept: 'Acceptați',
    accepted_success: 'Factura a fost acceptată cu succes',
    rejected_success: 'Factura a fost respinsă cu succes',
    reject: 'Respingeți',
    entry_added_success: 'Intrarea a fost adăugată cu succes',
    add_issuance: 'Adaugă eliberare',
    entry_form: 'Forma farmaceutică',
    unit_price_with_tva: 'Costul per unitate cu TVA inclus',
    total_amount: 'Preț total (MDL) cu costuri adiționale',
    product_details: 'Detalii despre produs',
    send: 'Trimiteți',
    confirm: 'Confirmă',
    restore: 'Restabilește'
  },
  stock_returns: {
    add_return: 'Adaugă returnare',
    returned: 'Returnat',
    return: 'Returnați',
    create_new_return: 'Creați o returnare nouă',
    register_return_invoice: 'Înregistrare factură de returnare',
    return_added_success: 'Cererea de returnare a fost creată cu succes',
    stock_return: 'Returnare de stoc',
    returns_from: 'Returnare de la',
    return_to: 'Până la'
  },
  stock_write_offs: {
    add_new_write_off: 'Adaugă o decontare nouă',
    edit_write_off: 'Editați decontarea',
    write_off: 'Act de decontare',
    register_number: 'Numărul de înregistrare',
    write_off_added_success: 'Decontare a fost adăugată cu succes',
    registration_number: 'Numărul de înregistrare',
    current_quantity: 'Cantitatea curentă',
    write_off_quantity: 'Cantitatea de decontare',
    issuance_from: 'Casari de la',
    issuance_to: 'Până la',
    initialized_by: 'Persoana care a inițiat decontarea',
    processed_by: 'Persoana care a procesat decontarea',
    restored_by: 'Persoana care a restabilit decontarea'
  },
  stock_issuance: {
    issuance_from: 'Eliberare de la',
    issuance_to: 'Până la'
  },
  stock_local: {
    local_quantity: 'În Stocul Instituției',
    requested_medicine: 'Medicamente și consumabile'
  },
  stock_filters: {
    producer: 'Producător',
    internationalName: 'Denumirea Internațională',
    internationalNameId: 'Denumirea Internațională',
    internationalNameIds: 'Denumirea Internațională',
    states: 'Stări',
    productGroupIds: 'Groupa',
    legalEntityIds: 'Instituție',
    roleIds: 'Rol',
    productGroupCategories: 'Categorie de stoc'
  },
  errors: {
    size_error: 'Mărimea fișierului este prea mare',
    extension_error: 'Tipul fișierului nu este acceptabil',
    something_went_wrong: 'Ceva nu a mers bine',
    fill_at_least_one_field: 'Completați cel puțin un câmp',
    quantity: 'Cantitatea nu poate fi mai mare de {{max}}',
    unitPrice: 'Prețul unitar nu poate fi mai mare de {{max}}',
    release: 'Nu poți elibera mai mult de {{max}}'
  },
  analysis: {
    analysis: 'Analiză',
    date: 'Data',
    analysis_type: 'Tipul de analiză',
    status: 'Statut',
    medic: 'Medic',
    analysed: 'Analizat',
    not_analysed: 'Ne analizat',
    collection_date: 'Data recoltării',
    result_date: 'Data rezultat',
    type: 'Tipul testului',
    quantitative_test: 'Test cantitativ',
    qualitative_test: 'Test calitativ',
    hiv_test: 'Rezultat TRD HIV 1+2',
    result: 'Rezultat',
    institution: 'Instituție',
    positive: 'Pozitiv',
    inconclusive: 'Inconcludent',
    negative: 'Negativ',
    medic_modal_title: 'Medicul care a solicitat testul',
    add_results: 'Adăugați rezultate',
    add_one_result: 'Adăugați rezultat',
    add_test_and_result: 'Adăugați test și rezultat',
    save_test_only: 'Salvați doar testul',
    retry_save_result: 'Reîncercați salvarea rezultatului',
    search_placeholder: 'Căutare după Cod SIME',
    cancel_test: 'Anularea testului',
    cancel_test_reason: 'Care a fost motivul anulării testului?',
    cancel_test_comments: 'Comentariile dumneavoastră',
    confirm_cancel_test: 'Doriți să anulați testul?',
    add_analysis: {
      add_analysis: 'Adăugați analiza',
      automatic_analysis: 'Adăugare automată',
      manual_analysis: 'Adăugare manuală',
      search_placeholder_analysis: 'Căutare după codul de analiză',
      scan_code: 'Scanați codul',
      scan_code_placeholder: 'Introducere Bar Cod Manuală',
      analysis_code: 'Сodul de analiză',
      suply_code: 'Cod spl.',
      middle_name: 'Patronimicul',
      birth_date: 'Data nașterii',
      speciment_type: 'Tipul specimentului',
      address: 'Adresa de domiciliu',
      add_test: 'Adăugați test',
      save_analysis: 'Salvați analiza',
      no_code_found: 'Nu au fost găsite persoane pentru căutarea dvs.',
      test_number: 'Test №',
      send_test_result: 'Trimiteți rezultatul la medic',
      test_sent: 'Transmis la Medic'
    },
    add_test: {
      add_test: 'Adăugați test',
      test_date: 'Data testarii/ora',
      bar_code: 'Bar Code',
      a1: 'A1 (Prima testare de screening)',
      a2: 'A2 (A doua testare de screening)',
      a3: 'A3 (Testul de confirmare)',
      print_code: 'Printați codul',
      consumable_materials: 'Denumire consumabil',
      received_quantity: 'Cantitate primită',
      add_consumable: 'Adăugare produs',
      save_test: 'Salvați testul'
    }
  },
  cases: {
    placeholder: 'Căutare după Cod SIME, Localitate',
    institution: 'Instituția care a notificat',
    request_access: 'Solicită access la date personale',
    send_request: 'Trimite solicitare',
    request_reason: 'Motivul solicitării',
    primary_request_reason: 'Motivul primar al solicitării',
    secondary_request_reason: 'Motive suplimentare al solicitării',
    new_patients: 'Au fost adăugați {{count}} pacienți noi',
    new_cases: 'Cazuri noi înregistrate în sistem',
    add_case: 'Adăugați caz',
    personal_data: 'Date personale',
    epidemiological_number: 'Număr Epidemiologic',
    institution_code: 'Codul instituției',
    institution_address: 'Adresa instituției',
    residential_address: 'Adresa de reședință',
    pregnant: 'Persoana însărcinată?',
    was_in_prison: 'A fost in penitenciar?',
    prison: 'Penitenciar',
    email_address: 'Adresa de email',
    succes_send_request: 'Solicitarea a fost trimisă cu succes',
    pre_test_counseling: 'A fost consiliat pre-test',
    post_test_counseling: 'A fost dat consilierul post-test'
  },
  visits: {
    add_visitor: 'Adăugați un vizitator',
    visit_date: 'Data vizitei',
    visitor_was_added: 'Vizitator a fost adăugat',
    visitor_was_added_description:
      'Vizitatorul a fost adăugat la lista dvs. de vizite.',
    thanks: 'Vă mulțumim',
    select_date: 'Selectați data și ora vizitei',
    current_date: 'Data de astăzi',
    planned_visit_date: 'Data vizitei planificate'
  },
  transfers: {
    transfer_patient: 'Transferarea pacientului',
    transfer_patient_reason: 'Motiv de transfer',
    gender: 'Gen',
    print: 'Printați',
    modal_title: 'Transfer către altă instituție medicală',
    patient_personal_data: 'Datele personale ale pacientului',
    idnp: 'Cod Personal (IDNP)',
    job: 'Locul de muncă (functia), studii',
    submission: 'Trimiterii:',
    consultation: 'La consultatie',
    investigation: 'Investigatie',
    stationary: 'In stationar',
    ambulatory_condition: 'a) de ambulatoriu: afectiunii',
    stationary_intern: 'b) de stationar (Intern)',
    stationary_extern: 'b) de stationar (Extern)',
    complete_diagnosis:
      'Diagnosticul complet (afectiunea de baza, complicatii concomitente)',
    complete_diagnosis_help:
      'Se completează de institetiile medicale la trimiterea pacientului pentru consultație, investigație, internare, externare (deces) și se prezinta medicului de familie.',
    investigation_label:
      'Anamneza pe scurt, investigatii diagnostice, tratamentul efectuat, evolutia bolii, starea sanatatii la trimitere, la externare',
    recommendations: 'Recomandatii curative si de munca',
    patient_belongs_medical_institution:
      'Instituție medicală de care aparține pacientul',
    transferring_medical_institution:
      'Instituție medicală la care vă transferați'
  },
  liberations: {
    liberation_date: 'Data eliberărării/ora'
  },
  reports_administration: {
    statistic_data: 'Date Statistice',
    assignee_report: 'Atribuiți raport',
    about_report: 'Despre raport',
    assignee_role: 'Atribuiți roluri',
    people_count: 'Număr total persoane',
    total_percentage: 'Procent din total',
    age_0_14: '0-14 ani',
    age_15_24: '15-24 ani',
    age_25_44: '25-44 ani',
    age_45_64: '45-64 ani',
    age_65: '65+ ani',
    men: 'Bărbați',
    women: 'Femei',
    import_data: 'Import de date',
    result_title: 'Documentul încărcat va înlocui datele!',
    add_report: 'Adaugă raport',
    edit_report: 'Editează raport',
    type: {
      stocksEntries: 'Intrări de stoc',
      stocksInquiries: 'Cereri de stoc'
    },
    report_created: 'Raportul a fost creat cu succes',
    report_updated: 'Raportul a fost actualizat cu succes',
    report_deleted: 'Raportul a fost șters cu succes',
    delete_report: 'Sigur doriți să ștergeți acest raport?'
  },
  persons: {
    external_result: {
      title: 'Adaugă rezultat extern',
      edit_title: 'Editează rezultatul extern',
      add: 'Rezultat extern',
      badge: 'Sursă externă',
      updated: 'Rezultatul a fost actualizat cu succes',
      deleted: 'Rezultatul a fost șters cu succes',
      delete_confirm: 'Sigur doriți să ștergeți acest rezultat extern?',
      patient: 'Pacient',
      select_patient: 'Selectați pacientul',
      select_patient_error: 'Selectați pacientul',
      sample_collected_at: 'Data recoltării probei',
      result_date: 'Data eliberării rezultatului',
      received_at: 'Data și ora recepției',
      conformity: 'Conformitatea probei',
      non_conformity_reason: 'Motivul neconformității',
      reception_not_saved:
        'Rezultatul a fost salvat, dar recepția nu a putut fi înregistrată',
      source_laboratory: 'Laborator sursă',
      source_laboratory_name: 'Denumirea laboratorului sursă',
      source_registered: 'Din sistem',
      source_free_text: 'Text liber'
    },
    prison_record: 'Istoric penitenciar',
    add_anonymous_person: 'Adaugă persoană anonimă',
    add_identified_person: 'Adaugă persoană identificată',
    anonymous_register: 'Înregistrare Anonimă',
    identified_register: 'Înregistrare Identificată',
    search_person: 'Căutare persoane',
    person_management: 'Gestionare Persoane',
    idnp_name_surname_sime_code:
      'IDNP, Nume, Prenume, Cod Sime sau Cod Testrap',
    add_new_person: 'Adăugați o persoană nouă',
    search_new_person: 'Căutați o persoană nouă',
    from_date_of_birth: 'De la data nașterii',
    to_date_of_birth: 'Până la data nașterii',
    search_persons: 'Căutați persoane',
    with_idnp: 'Prin IDNP',
    with_personal_date: 'Prin Date Personale',
    is_already_registered_person:
      'Această persoană este înregistrată la un alt spital!',
    person_details: 'Informații despre persoană',
    person_treatments: 'Tratamente',
    person_investigations: 'Investigații',
    'person_investigation-results': 'Rezultate investigații',
    personal_details_card: 'Date personale',
    screening_investigation_card: 'Investigație screening',
    treatment_card: 'Tratament',
    diagnostic_card: 'Diagnostic',
    next_visit_card: 'Următoarea vizită',
    case_status_label: 'Status caz',
    treatment_type_label: 'Tip tratament',
    start_date_label: 'Data început',
    end_date_label: 'Data sfârșit',
    'person_epidemiology-cases': 'Cazuri epidemiologice și SIDA',
    person_visits: 'Vizite',
    person_pregnancy: 'Monitorizare Prenatală',
    person_pregnancy_details: 'Detalii Monitorizare Prenatală',
    person_recipes: 'Rețete',
    person_tutor: 'Tutelă',
    person_consultations: 'Consultații',
    person_history: 'Istoricul modificărilor',
    person_screening: 'Investigații',
    'person_preventive-treatment': 'Tratament preventiv',
    'person_risk-groups': 'Grupuri de risc',
    'person_sida-notification': 'Fișă SIDA',
    'person_transfer-history': 'Istoricul transferelor',
    person_diagnoses: 'Diagnostice',
    diagnoses_primary: 'Diagnostic primar',
    diagnoses_final: 'Diagnostic final',
    diagnoses_history: 'Istoricul diagnosticelor din consultații',
    add_tutor_idnp: 'Asigneaza tutore (IDNP)',
    add_tutor_manual: 'Adaugă tutore prin date personale',
    patient_transfer: 'Transfera Pacient',
    assigned_persons: 'Persoane asignate',
    patient_registered_successfully:
      'Persoana a fost înregistrat cu succes ca pacient',
    add_manual_person: 'Adăugați manual o persoană',
    residence_address_same_current_address:
      'Adresa de reședință la fel ca și adresa de trai',
    live_address_same_current_address:
      'Adresa de trai la fel ca și adresa de reședință',
    add_person_success: 'Persoana a fost adăugată cu success',
    alocate_doctor: 'Alocă un medic',
    transfer: 'Transfer către altă instituție',
    person_information: 'Informații despre pacient',
    save: 'Salvați',
    investigated: 'Investigat',
    notInvestigated: 'Neinvestigat',
    no_tutor: 'Nu necesită tutore',
    child_tutor: 'Este persoană sub tutelă (Copil)',
    parent_tutor: 'Este tutore (Părinte)',
    add_tutor: 'Adăugați tutelă',
    no_person_found: 'Nu au fost găsite persoane pentru căutarea dvs.',
    exists_in_system: 'Această persoană există deja în sistem',
    delete_tutor: 'Ștergeți tutela?',
    same_person_tutor_error: 'Persoana nu poate fi tutore pentru sine',
    person_quiz: 'Chestionare',
    case_status: {
      title: 'Statut caz',
      possibleCase: 'Caz posibil (A1)',
      probableCase: 'Caz probabil (A2)',
      confirmedCase: 'Caz confirmat (A3)'
    },
    register_as_patient: 'Înregistrează ca pacient',
    delete_penitentiary_record: 'Ștergeți isotricul penitenciar?',
    delete_penitentiary_record_successfully:
      'Isotricul penitenciară a fost ștearsă cu succes.',
    allow_create_patient_account:
      'Consiliere pacient referitor la diagnostic pentru crearea contului pacientului',
    create_patient_account: 'Creeare cont pacient',
    create_patient_account_success:
      'Contul pacientului a fost creat cu success',
    assigned_doctors: 'Medici asignați',
    add_doctor: 'Adăugați medic',
    delete_doctor: 'Medicul a fost șters cu succes',
    select_doctor: 'Selectați medicul',
    select_doctor_warning: 'Vă rugăm să selectați cel puțin un medic',
    select_all_doctors: 'Selectați toți medicii',
    added_doctor_successfully: 'Medicul a fost adăugat cu succes',
    added_doctors_successfully: 'Medicii au fost adăugați cu succes',
    investigations: {
      investigation_number: 'Investigație №',
      investigation_new: 'Cerere pentru o nouă investigație',
      investigation_result: 'Rezultatul investigației',
      investigation_date: 'Data investigației',
      request_new_investigation: 'Cerere pentru analiză de laborator',
      select_investigation_test_type: 'Selectați tipul de test'
    },
    visits: {
      reserve_date: 'Programați data vizitei'
    },
    treatment: {
      treatment_number: 'Tratament №',
      start_date: 'Începutul tratamentului',
      end_date: 'Data următoarei vizite',
      prescribed_date: 'Data administrării',
      treatment_prescribed: 'Tratament prescris',
      treatment_administered: 'Tratament administrat',
      start_date_invalid:
        'Selectați o dată corectă pentru începutul tratamentului.',
      end_date_invalid:
        'Selectați o dată corectă pentru finalizarea tratamentului.',
      medicine_start_invalid:
        'Selectați o dată corectă pentru începutul medicamentului.',
      medicine_end_invalid:
        'Selectați o dată corectă pentru finalizarea medicamentului.',
      prescribed_treatment_added:
        'Preparatul prescris a fost adăugat cu succes',
      prescribed_treatment_updated:
        'Preparatul prescris a fost actualizat cu succes',
      prescribed_treatment_deleted:
        'Preparatul prescris a fost șters cu succes',
      cannot_delete_administered:
        'Nu puteți șterge un preparat care a fost deja administrat',
      treatment_updated: 'Tratamentul a fost actualizat cu succes'
    },
    sime_tb_access: 'Acceseaza tratament Sime TB',
    notify_tb_new_case: 'Notifică caz nou TB',
    notify_tb_new_case_success: 'Cazul nou TB a fost notificat cu succes',
    sime_tb_treatments: 'Tratament Sime TB',
    show_history: 'Vezi istoricul modificărilor',
    history_modal_title: 'Istoricul modificărilor',
    create_patient_account_description:
      'Pentru a crea contul pacientului, este necesar să aveți un diagnostic principal.'
  },
  support_investigation: {
    add_org: 'Adăugați organizație',
    select_placeholder: 'Selectați Organizația Neguvernamentală asociata',
    org_name: 'Denumire Organizația',
    people_count: 'Numarul de Persoane',
    add_people: 'Adăugați persoane',
    delete_org: 'Ștergeți organizația',
    upload_idnp: 'Încarcă din fișier IDNP-urile',
    not_analyzed: 'Nu analizat'
  },
  recipes: {
    placeholder: 'IDNP, Nume, Prenume sau Cod Sime',
    date_issued: 'Data emiterii',
    date_dispensing: 'Data de eliberare',
    date_issued_asc: 'Data emiterii (A - Z)',
    date_issued_desc: 'Data emiterii(Z - A)',
    date_dispensing_asc: 'Data de eliberare (A - Z)',
    date_dispensing_desc: 'Data de eliberare (Z - A)',
    person_who_created_the_recipe: 'Persoana care a creat rețeta',
    administred_treatment: 'Administrare Tratament',
    status: {
      new: 'Nouă',
      dispensed: 'Eliberată',
      declined: 'Refuzată',
      cancelled: 'Anulată'
    },
    decline_confirm_title: 'Sigur doriți să refuzați această rețetă?',
    dispense_confirm_title: 'Sigur doriți să eliberați această rețetă?',
    success_declined: 'Rețeta a fost refuzată cu succes',
    success_dispensed: 'Rețeta a fost eliberată cu succes',
    patient_information: 'Informații pacient',
    commercial_name: 'Denumirea comercială',
    requested_quantity: 'Cantitatea solicitată'
  },
  pregnancy_monitoring: {
    register_new_examination: 'Înregistrați o examinare nouă',
    national_clinical_protocol: 'Protocol clinic național',
    read_guide: 'Citește ghidul',
    prompt_domain: 'Domeniul prompt',
    imsp_audit: 'Denumirea IMSP evaluată prin audit',
    uid: 'Identificatorul unic al pacientei în sistemul informațional',
    responsible_person: 'Persoana responsabilă de completarea fișei',
    medic: 'Medicul curant',
    birth_date: 'Data nașterii a pacientei',
    residency_medium: 'Mediul de reședință',
    urban: 'Urban',
    unknown: 'Necunoscut',
    rural: 'Rural',
    dispensary_record: 'Evidența de dispensar',
    diagnosis_date: 'Data stabilirii diagnosticului HIV',
    probable_route_of_infection: 'Calea probabilă de infectare',
    registration_date:
      'Data luării în evidență de dispensar (conform registrului de evidență a pacienților cu HIV)',
    diagnosis: 'Diagnosticul',
    hiv_rna_level:
      'A fost determinat nivelul ARN HIV la 36 de săptămâni de sarcină?',
    hiv_rna_level_ml: 'Nivelul ARN HIV, copii/ml',
    undetermined: 'Nedeterminat',
    lower_50: '<50',
    between_50_1000: '50 - 1000',
    greater_1000: '1000+',
    hiv_rna_level_date: 'Data determinării nivelului ARN HIV',
    treatment: 'Tratamentul',
    arv_treatment_initiated:
      'Tratamentul ARV a fost inițiat (inclusiv în naștere)?',
    no_patient_refused: 'Nu, refuzul pacientei',
    no_other_reasons: 'Nu, alte motive',
    azt_treatment_at_birth: 'În naștere s-a oferit tratament cu AZT adăugător?',
    initiated_treatment_date: 'Când a fost inițiat tratamentul?',
    children_birth_date: 'Data nașterii copiilor',
    was_interruptions_in_art: 'A fost întreruperi în TARV? ',
    mode_of_birth: 'Modul de naștere',
    physiological: 'Fiziologică',
    caesarean_operation: 'Operație Cezariană',
    was_on_art_during_delivery: 'În timpul nașterii se află în TARV?',
    number_of_children_born: 'Numărul copiilor născuți',
    number_of_children_born_alive: 'Numărul copiilor născuți vii',
    initiation_date_of_last_tar:
      'Data reinițierii ultimului TARV înainte de naștere',
    evaluation_date: 'Data evaluării',
    add: 'Adaugă examinare'
  },
  restricted_access: {
    title: 'Ne pare rău, nu sunteți autorizat să accesați această pagină.',
    back_home: 'Înapoi la pagina principală'
  },
  counterparts: {
    title: 'Contraparte',
    add_counterpart: 'Adăugați un furnizor nou',
    producer_name: 'Prestator de servicii',
    contract_number: 'Nr. Contract',
    active_from: 'Activ din',
    active_to: 'Până la',
    status: 'Statut',
    active: 'Activ',
    inactive: 'Inactiv',
    counter_part_deleted: 'Contrapartea a fost ștearsă cu succes',
    delete_counterpart: 'Sigur doriți să ștergeți această contraparte?',
    provider_created: 'Contrapartea a fost creată cu succes',
    no_contracts_found: 'Nu există nici un contract.',
    add_new_contract: 'Adăugați un contract nou',
    add_new_template_contract: 'Salvați ca schiță',
    contracts: 'Contracte',
    draft: 'Template contracte',
    template_name: 'Denumire template',
    template_description: 'Descriere template',
    template_created: 'Template-ul a fost creat cu succes',
    template_updated: 'Template-ul a fost actualizat cu succes',
    create_new_contract_based_on_this_template:
      'Creați un nou contract bazat pe acest template',
    template_deleted: 'Template-ul a fost șters cu succes',
    contact_created: 'Contactul a fost creat cu succes',
    provider: 'Furnizor',
    purchase_center: 'Beneficiar',
    distributor: 'Distribuitor',
    signed_date: 'Data semnării contractului',
    contract_start_date: 'Data intrării în funcție a contractului',
    contract_end_date: 'Data finalizării contractului',
    intern_number: 'Nr. intern / Gestiune',
    additional_files: 'Fișiere adiționale',
    description: 'Descriere',
    contact_deleted: 'Contractul a fost șters cu succes',
    delete_contract: 'Ștergeți contractul?',
    sort_contract_by_number: 'Nr. Contract (cresc.)',
    sort_contract_by_number_desc: 'Nr. Contract (descresc.)',
    sort_contract_by_date: 'Data activării (cresc.)',
    sort_contract_by_date_desc: 'Data activării (descresc.)',
    sort_contract_by_end_date: 'Data încheierii (cresc.)',
    sort_contract_by_end_date_desc: 'Data încheierii (descresc.)',
    add_product: 'Adaugă produs',
    quantity: 'Cantitatea Contractată',
    delivered_quantity: 'Cantitate livrată',
    outstanding_quantity: 'Cantitate Restantă'
  },
  medicine_register: {
    title: 'Registru Medicamente și Consumabile',
    upload_medicines: 'Încărcați medicamente',
    provider: 'Furnizor',
    upload_error: 'Vă rugăm să încărcați un document',
    count: 'Nr. elemente',
    products: {
      title: 'Medicamente',
      description:
        'Numele sub care medicamentul este cunoscut și comercializat. Poate fi un nume de marcă sau un nume generic, important pentru recunoașterea și prescrierea corectă.',
      delete: 'Sigur doriți să ștergeți acest medicament ?',
      delete_success: 'Medicamentul a fost șters cu succes',
      add: 'Adaugă denumire comercială',
      prescription: 'Prescriere',
      dose: 'Doza',
      volume: 'Volum',
      division: 'Divizare',
      validity_period: 'Valabilitatea (luni)',
      name: 'Denumire'
    },
    international_name: {
      title: 'Denumire Internațională',
      description:
        'Numele recunoscut internațional (de obicei DCI – Denumirea Comună Internațională) care definește compusul activ al medicamentului, standardizat pentru uzul global.',
      all: 'Toate',
      only_used: 'Doar folosite',
      only_not_used: 'Doar nefolosite',
      delete: 'Sigur doriți să ștergeți această denumire internațională ?',
      delete_success: 'Denumirea internațională a fost ștearsă cu succes',
      name: 'Denumire internațională',
      add_name: 'Adaugă denumire internațională',
      edit_name: 'Editează denumirea internațională',
      is_used: 'Este folosit'
    },
    pharmaceutical_form: {
      title: 'Forma Farmaceutică',
      description:
        'Forma de prezentare fizică a medicamentului, cum ar fi tabletă, capsulă, soluție injectabilă, sirop, unguent etc., adaptată pentru administrare corespunzătoare și eficiență terapeutică.',
      delete: 'Sigur doriți să ștergeți această formă farmaceutică ?',
      delete_success: 'Formă farmaceutică a fost ștearsă cu succes',
      add_form: 'Adaugă forma farmaceutică',
      edit_form: 'Editează forma farmaceutică'
    },
    producers: {
      title: 'Compania Producătoare',
      description:
        'Numele firmei sau organizației care fabrică medicamentul, responsabilă de respectarea standardelor de calitate și siguranță.',
      delete: 'Sigur doriți să ștergeți această companie ?',
      delete_success: 'Compania a fost ștearsă cu succes',
      add_company: 'Adaugă companie producătoare',
      edit_company: 'Editează companie producătoare',
      name: 'Compania producătoare'
    },
    consumables: {
      title: 'Parafarmaceutice',
      add: 'Adaugă parafarmaceutic',
      delete: 'Sigur doriți să ștergeți acest parafarmaceutic ?',
      delete_success: 'Parafarmaceutic-ul a fost șters cu succes',
      measurement_unit: 'Unitate de măsură',
      unit_size: 'Dimensiunea',
      unit_count: 'Cantitatea'
    },
    units: {
      title: 'Unități de măsură',
      add_unit: 'Adaugă unitate de măsură',
      edit_unit: 'Editează unitatea de măsură',
      delete: 'Sigur doriți să ștergeți această unitate de măsură ?',
      delete_success: 'Unitatea de măsură a fost ștearsă cu succes',
      name: 'Nume'
    }
  },
  pre_screening: {
    document_number_asc: 'Număr document (cresc.)',
    document_number_desc: 'Număr document (descresc.)',
    add_new_people: 'Adăugați persoane',
    sent_to_ong: 'Trimite lista către ONG',
    delete_list_title: 'Sigur doriti sa stergeti aceasta lista?',
    ong: 'ONG',
    document_number: 'Număr document',
    person_count: '№ persoane',
    new: 'Nou',
    sent: 'Trimis',
    pre_screening: 'Pre-screening',
    not_found: 'Nu a fost găsit',
    add_new_list: 'Creați o listă nouă',
    document_date: 'Data documentului',
    edit_list: 'Editați lista',
    sent_to_ong_confirm: 'Trimiteți lista către ONG?',
    finished_screening: 'Au trecut pre-screening',
    not_found_screening: 'Nu au fost găsite',
    screening_date: 'Data screening',
    person_registered_from: 'Înregistrat în sistem de către',
    person_group: 'Grupul (categoria) de populație',
    screening_day: 'Data zilei de screening'
  },
  qr_code: {
    scan_qr_code: 'Scanare QR Cod',
    scan_code: 'Scanați codul',
    enter_code_manually: 'Introduceți codul manual',
    invalid_code: 'Acest cod nu este valid',
    required_permission:
      'Nu aveți permisiunile necesare pentru a efectua această acțiune',
    unsupported_qr_type: 'Acest tip de cod QR nu este suportat',
    view_qr_code: 'Afișați Cod QR'
  },
  tests: {
    created_from_date: 'De la data creării',
    created_to_date: 'Până la data creării',
    add_test: 'Adăugați probă',
    test_datetime: 'Data/ora testării',
    code: 'Cod probă',
    result_datetime: 'Data/ora rezultat',
    add_test_automatically: 'Adăugare automată',
    add_test_manually: 'Adăugare manuală',
    reception: 'Receptionare',
    successfully_receptioned: 'Probă receptionată cu succes',
    specimen_details: 'Detalii probă',
    statuses: {
      created: 'Creat',
      harvested: 'Recoltat',
      inProgress: 'În așteptare',
      canceled: 'Anulat',
      completed: 'Finalizat',
      sentToLaboratory: 'Trimis la laborator',
      received: 'Receptionat',
      rejected: 'Respins'
    },
    laboratory_statuses: {
      received: 'Receptionat',
      inconform: 'Neconform',
      sentToValidation: 'Trimis la validare',
      validated: 'Acceptat',
      rejected: 'Respins'
    },
    testDone: 'Validat'
  },
  tb_screening: {
    title: 'Screening TB (la fiecare vizită)',
    subtitle:
      'Verificați simptomele TB și contactul recent cu un bolnav de TB. Oricare răspuns „Da” necesită examinarea pentru TB activă.',
    cough: 'Tuse prezentă',
    fever: 'Febră',
    weight_loss: 'Pierdere ponderală',
    night_sweats: 'Transpirații nocturne',
    recent_tb_contact: 'Contact recent cu un bolnav de TB',
    is_hospitalized: 'Pacient spitalizat',
    positive_alert:
      'Screening TB pozitiv — pacientul necesită examinare pentru TB activă',
    recommended: 'Examinări recomandate:',
    rec_crp: 'Proteina C-reactivă (valoare > 5 mg/l sugestivă pentru TB)',
    rec_xray: 'Radiografie toracică',
    rec_lf_lam: 'LF-LAM Ag (CD4 < {{threshold}} celule/µl)',
    rec_xpert: 'Xpert MTB/RIF',
    rec_phthisiatrician: 'Consultația ftiziatrului (trimitere)',
    lf_lam_recommended:
      'Recomandat: ultimul CD4 = {{value}} celule/µl ({{date}})',
    lf_lam_not_required:
      'Ultimul CD4 = {{value}} celule/µl ({{date}}) — peste pragul de {{threshold}}',
    cd4_unknown: 'Nu există un rezultat CD4 în sistem',
    request_lab: 'Solicită investigații TB în laborator',
    workup_title: 'Examinarea pentru TB activă',
    crp: 'Proteina C-reactivă (mg/l)',
    crp_above: 'Peste 5 mg/l — sugestiv pentru TB',
    crp_date: 'Data PCR',
    chest_xray: 'Radiografie toracică',
    chest_xray_date: 'Data radiografiei',
    lf_lam: 'LF-LAM Ag',
    lf_lam_date: 'Data LF-LAM',
    xpert: 'Xpert MTB/RIF',
    xpert_date: 'Data Xpert MTB/RIF',
    referral: 'Trimis la consultația ftiziatrului',
    referral_date: 'Data trimiterii',
    referral_notes: 'Note pentru ftiziatru',
    tb_positive_alert:
      'TB confirmat — după salvare, trimiteți pacientul în SIME TB („Notifică caz nou TB” pe pagina pacientului).',
    not_done: 'Neefectuat',
    chest_xray_result: {
      normal: 'Normală',
      suggestiveOfTb: 'Sugestivă pentru TB'
    },
    test_result: {
      positive: 'Pozitiv',
      negative: 'Negativ'
    },
    xpert_result: {
      mtbNotDetected: 'MTB nedetectat',
      detectedRifSensitive: 'MTB detectat, RIF sensibil',
      detectedRifResistant: 'MTB detectat, RIF rezistent',
      detectedRifIndeterminate: 'MTB detectat, RIF nedeterminat',
      invalid: 'Invalid / eroare'
    },
    screening_negative: 'Screening TB negativ',
    screening_positive: 'Screening TB pozitiv',
    active_scheme_title: 'Schema de tratament TB activă (SIME TB)',
    active_scheme_none: 'Nu există o schemă de tratament TB activă în SIME TB',
    active_scheme_start: 'Data începerii',
    active_scheme_regimen: 'Schema'
  },
  consultations: {
    new_consultation: 'Consultație nouă',
    add_new_consultation: 'Adaugă consultație nouă',
    institution_name_asc: 'Denumire instituție (A - Z)',
    institution_name_desc: 'Denumire instituție (Z - A)',
    consultation_type_asc: 'Tip consultație (A - Z)',
    consultation_type_desc: 'Tip consultație (Z - A)',
    search_placeholder: 'Căutare după denumire instituție',
    consultation_type: 'Tipul consultației',
    status: {
      scheduled: 'Planificată',
      present: 'Prezentă',
      absent: 'Absentă'
    },
    personStatus: {
      scheduled: 'Urmează',
      present: 'Finalizat',
      absent: 'Absentă'
    },
    register_new_consultation: 'Înregistrați o consultație nouă',
    get_latest_info: 'Preia date din consultația precedentă',
    consultation_date: 'Data consultației',
    pregnant_women: 'Femeie însărcinată',
    delete_consultation: 'Sigur doriți să ștergeți această consultație ?',
    success_delete_consultation: 'Consultarea a fost ștearsă cu succes',
    reschedule_consultation: 'Replanificați consultația',
    manage_consultation: 'Gestionați consultația',
    edit_consultation: 'Editează consultația',
    success_update: 'Consultația a fost actualizată cu succes',
    edit_until_end_of_day:
      'Consultația poate fi editată doar de dvs. și doar astăzi, până la ora 23:59.',
    edit_period_expired:
      'Consultația nu mai poate fi editată: doar autorul o poate edita, în ziua efectuării (până la ora 23:59).',
    treatment_plan_read_only:
      'Planul de tratament existent nu se modifică la editarea consultației.',
    success_create: 'Consultația a fost creată cu succes',
    save_as_draft: 'Salvați ca schiță',
    draft: 'Schiță',
    draft_saved: 'Schița a fost salvată cu succes',
    draft_updated: 'Schița a fost actualizată cu succes',
    autosave_session_expiring: 'Sesiunea expiră în curând',
    autosave_draft_saved:
      'Consultația a fost salvată automat ca schiță înainte de expirarea sesiunii.',
    from_draft: 'Din schiță',
    draft_name: 'Denumirea schiței',
    draft_description: 'Descrierea schiței',
    select_draft: 'Selectați o schiță',
    no_drafts: 'Nu există schițe salvate',
    draft_deleted: 'Schița a fost ștearsă cu succes',
    schedule_consultation: 'Planificați consultația',
    schedule_new_consultation: 'Planificați o consultație nouă',
    select_date_and_time: 'Selectați data și ora consultației',
    consultation_scheduled_successfully:
      'Consultația a fost programată cu succes',
    consultation_rescheduled_successfully:
      'Consultația a fost reprogramată cu succes',
    select_options:
      'Selectați opțiunile care trebuie incluse în această consultație:',
    preliminary_information: 'Informații preliminare',
    epidemiological_case: 'Caz Epidemiologic',
    treatment: 'Tratament',
    add_new_treatment: 'Adăugați un tratament nou',
    active_substance: 'Substanța activă',
    dose: 'Dozaj',
    daily_quantity: 'Cantitate (zi)',
    duration_days: 'Durata (zile)',
    recipes: 'Rețete',
    add_new_recipe: 'Adăugați rețetă',
    report_adverse_reaction: 'Raportați reacții adverse',
    add_person_as_pacient:
      'Odată cu programarea consultației, creați și un cont al pacientului în sistem.',
    adverse_reaction_date: 'Data întâmplării evenimentului',
    accuse: 'Acuze',
    preliminary_diagnostic: 'Diagnosticul preliminar',
    preliminary_notes_placeholder:
      'Adaugă notițe precum anamneza, starea persoanei, etc',
    investigation_request: 'Cerere de investigare',
    new_investigation_request: 'Cerere pentru o nouă investigație',
    tb_investigations: 'Investigații TB',
    new_tb_investigation_request: 'Cerere pentru o nouă investigație TB',
    direction_to: 'Îndreptare către',
    select_laboratory: 'Selectați laborator',
    investigation_created_successfully:
      'Cererea de investigare a fost creată cu succes',
    previous_tests: 'Teste anterioare',
    harvest_date: 'Data testării',
    final_diagnostic: 'Diagnostic',
    aids_clinical_category: '55.2. Categoria clinică SIDA',
    aids_clinical_category_required:
      'Categoria clinică SIDA este obligatorie pentru diagnosticul de infecție HIV (B20–B24, Z21)',
    aids_clinical_category_hint:
      'Obligatoriu când diagnosticul este infecție HIV (B20–B24, Z21)',
    aids_clinical_conditions: 'Afecțiuni clinice – categoria {{category}}',
    aids_clinical_conditions_hint:
      'Categoria C rămâne definitivă odată apărută; bolile din categoria B au prioritate față de A.',
    cd4_count_latest: 'CD4: {{count}} cel/µl ({{date}})',
    cd4_percent_latest: 'CD4%: {{percent}}% ({{date}})',
    cd4_no_results: 'CD4: nu există rezultate',
    cd4_suggested_category: 'Categoria CD4 sugerată: {{category}} ({{range}})',
    recipe_number: '№ rețetă',
    recipe_date: 'Data Rețetei',
    new_recipe: 'Nouă',
    dispensed_recipe: 'Eliberată',
    cancelled_recipe: 'Anulată',
    refused_recipe: 'Refuzată',
    add_new_recipe_title: 'Adăugați o rețetă nouă',
    preparation_name: 'Denumire preparat',
    recipe_added_successful: 'Rețeta a fost adăugată cu succes',
    specimen_type: 'Tip specimen',
    specimen: 'Specimen',
    add_specimen: 'Adaugă specimen',
    add_institution: 'Adaugă instituția',
    select_specimen_type: 'Selectați tipul specimenului',
    contacts: 'Contacte',
    contacts_add: 'Adaugă contacte',
    contacts_exists: 'Este deja în contacte',
    contacts_add_self_error: 'Nu te poți adăuga pe tine ca contact',
    examination: 'Fise primara / secundara'
  },
  investigations: {
    search_placeholder: 'Căutare după № investigație',
    created_date: 'Data creării',
    performed_datetime: 'Data și ora efectuării',
    performed_date: 'Data efectuării',
    harvest_date: 'Data și ora recoltării',
    investigation_number: '№ investigație',
    categories: 'Categorii',
    category: 'Categorie',
    investigation_reason: 'Motivul investigației',
    anonymous: 'Anonim',
    no_investigations: 'Nicio investigație',
    assign_investigation_demand: 'Recoltați proba',
    select_harvest_date_and_time: 'Selectați data și ora recoltării',
    success_assigned_investigation: 'Proba a fost recoltată cu succes',
    close: 'Închideți',
    investigation_details: 'Detalii probă',
    cancel_investigation: 'Anularea probei',
    cancellation_reason: 'Motivul anulării probei',
    treatment_reason: 'Motivul tratamentului',
    cancellation_comments: 'Comentariile dumneavoastră',
    investigation_cancelled_successfully: 'Proba a fost anulată cu succes',
    investigation: 'Probă',
    investigation_code: 'Сodul de Probă',
    tests: 'Teste',
    laboratory_tehnic: 'Tehnician de laborator:',
    test_created_successfully: 'Testul a fost creat cu succes',
    test_number: '№ test',
    test_details: 'Detalii test',
    registration_number: 'Nr. de înregistrare',
    successfully_added_result: 'Rezultatul a fost adăugat cu succes',
    cantitative_test: 'Testul cantitativ',
    xpert: 'Xpert VL HIV-1',
    other: 'Altele (denumirea)',
    hiv1: 'HIV-1',
    hiv1_suffix: 'copii/ml',
    hiv1_placeholder: '№ copii/ml',
    calitative_test: 'Testul calitativ',
    hiv1_detected: 'HIV-1 detectat',
    hiv1_undetected: 'HIV-1 nedetectabil',
    hiv2: 'HIV-2',
    trd_result: 'Rezultat TRD HIV-1/2 (denumirea)',
    trd_result_placeholder: 'Introduceți denumirea testului',
    xpert_qual: 'Xpert Qual HIV-1',
    successfully_send_result: 'Rezultatul a fost transmis cu success',
    approved_date: 'Data aprobării',
    approved_by: 'Aprobat de către medicul',
    search_by_code: 'Căutare după codul de probă',
    not_found_investigation:
      'Nu a fost găsită nici o probă pentru codul introdus',
    add_person: 'Adăugați persoană',
    search_by_person_code: 'Căutare după Cod SIME, Cod TARV',
    want_to_cancel_investigation: 'Doriți să anulați proba?',
    add_at_least_one_result: 'Adăugați cel puțin un rezultat',
    stock_quantity: 'Cantitatea în stoc',
    insufficient_quantity_stock: 'Cantitate insuficientă în stoc',
    person_error: 'Este necesară asignarea persoanei la probă',
    conform: 'Conformă',
    not_conform: 'Neconformă',
    reception_date: 'Data și ora recepționării',
    investigation_reception: 'Recepționarea probei',
    reception: 'Recepționare',
    investigation_status: 'Stare proba',
    validate: 'Validare',
    reject: 'Respingere',
    validate_investigation: 'Acceptarea probei',
    validate_investigation_success: 'Proba a fost acceptată cu succes',
    reject_investigation: 'Respingere probă',
    reject_investigation_success: 'Proba a fost respinsă cu succes',
    reject_reason: 'Motivul respingerii',
    internal_code: 'Cod intern',
    approved: 'Aprobat / Validat',
    view_results: 'Vizualizare rezultate',
    result_value: 'Valoarea rezultatului',
    result_numeric_value: 'Valoare numerică rezultatului',
    tested_at: 'Diagnostic',
    send_to_validation: 'Trimite testul la validare',
    send_all: 'Trimite toate rezultatele',
    successfully_send_to_validation:
      'Testul a fost trimis la validare cu succes',
    successfully_rejected_test: 'Testul a fost respins cu succes',
    reject_test: 'Respinge testul',
    select_category: 'Selectați investigații de la instituția curentă',
    select_category_from_other_institutions:
      'Selectați investigații de la alte instituții',
    sent_to_laboratory_at: 'Trimis la laborator la',
    temperature: 'Temperatura probei la receptionare',
    reject_test_result: 'Respinge rezultatul testului',
    referral_doctor: 'Medicul care a trimis pacientul',
    referral_doctor_name: 'Numele medicului care a trimis pacientul',
    referral_doctor_registered: 'Din sistem',
    referral_doctor_free_text: 'Text liber'
  },
  questionnaires: {
    search_by_title: 'Căutare după titlu',
    questions_count: 'Nr. de întrebări',
    move_to_draft: 'Mutați în Draft',
    create_copy: 'Creați o copie',
    publish: 'Publicați',
    questionnaire_title: 'Titlu chestionar',
    question: 'Întrebare',
    preview: 'Previzualizare',
    draft: 'Draft',
    active: 'Activ',
    inactive: 'Inactiv',
    create_new_questionnaire: 'Creați un chestionar nou',
    edit_questionnaire: 'Editați chestionar',
    questionnaire_desc: 'Descriere chestionar',
    questions: 'Întrebări',
    answers: 'Raspunsuri',
    question_type: 'Tipul de intrebare',
    add_question: 'Adaugați intrebare',
    add_option: 'Adaugaț optiune',
    delete_question: 'Sigur doriți să ștergeți această intrebare ?',
    delete_option: 'Sigur doriți să ștergeți această optiune ?',
    singleChoice: 'Un singur raspuns',
    multipleChoice: 'Raspunsuri multiple',
    persons: 'pers.',
    persons_count_completed_questionnaire: 'Au completat chestionarul',
    no_person_completed_this_questionnaire:
      'Nici un pacient nu a completat chestionarul',
    back_to_edit: 'Inapoi la editare',
    quiz_shared: 'Chestionare distribuite',
    quiz_not_shared: 'Chestionare nedistribuite',
    cannot_share_quiz_with_no_questions:
      'Nu se pot distribui chestionare cu nici o intrebare',
    quiz_has_no_answers: 'Chestionarul nu are nici un raspuns',
    answered: 'Raspunse',
    notAnswered: 'Neraspunse',
    completed: 'Completat',
    not_completed: 'Necompletat',
    has_free_text: 'Are raspuns deschis?'
  },
  pregnancy: {
    pregnancy: 'Monitorizare Prenatală',
    age: 'Vârsta gestațională',
    last_gestation_date: 'Data ultimei menstruații (DUM)',
    estimated_birth_date: 'Data estimativă a nașterii (DEN)',
    pregnancy_type: 'Tipul sarcinii',
    pregnancy_status: 'Statutul sarcinii',
    pregnancy_localization: 'Localizarea sarcinii',
    registration_date: 'Data înregistrării',
    DUM: 'DUM',
    DEN: 'DEN',
    interrupted: 'Intrerupta',
    completed: 'Finalizat',
    inProgress: 'În monitorizare',
    monitoring_period: 'Perioada de monitorizare',
    monitoring_test: 'Test monitorizare sarcina',
    pregnant_localization_status: {
      intrauterine: 'Intrauterin',
      extrauterine: 'Extrauterină'
    },
    pregnancy_type_status: {
      singular: 'Singulară',
      multiple: 'Multipla'
    },
    pregnancy_actions_statuses: {
      cesareanSection: 'Operație cezariană',
      interruptedPregnancy: 'Sarcină întreruptă',
      pregnantPerson: 'Persoană însărcinată',
      lostPregnancy: 'Sarcină pierdută',
      naturalBirth: 'Naștere naturală'
    },
    interrupted_pregnancy_reason: 'Motivul întreruperii sarcinii',
    interrupted_pregnancy_reasons: {
      highRiskForMotherHealth: 'Risc înalt pentru sănătatea mamei',
      severeChildCongenitalMalformation:
        'Malformație congenitală severă a copilului',
      otherMedicalReasons: 'Alte motive medicale'
    },
    newBorns: 'Nou-născuți',
    newBorns_investigations: 'Investigații nou-născuți',
    births: 'Nașteri',
    birth_date: 'Data nașterii',
    birth_type_status: 'Tipul nașterii',
    birth_type: {
      natural: 'Naștere naturală',
      unknown: 'Necunoscut',
      cesareanSection: 'Operație cezariană'
    },
    period_type_status: 'Tipul perioadei',
    period_type: {
      fullTermPregnancy: 'Sarcină la termen',
      premature: 'Sarcină prematură'
    },
    add_new_birth: 'Adăugați naștere',
    view_new_birth: 'Vizualizare naștere',
    add_newborn: 'Adăugați nou-născut',
    feeding_type: 'Tipul hrănirii',
    feeding_types: {
      natural: 'Naturală',
      artificial: 'Artificială'
    },
    newborn_status: 'Starea nou-născutului',
    newborn_statuses: {
      healthy: 'Sănătos',
      hiv: 'Hiv',
      deceased: 'Decedat'
    },
    investigation_limit_date: 'Data limită de investigație',
    current_weight: 'Greutatea actuală (KG)',
    current_height: 'Înălțimea actuală (cm)',
    birth_date_from: 'Data nașterii de la',
    birth_date_to: 'Data nașterii până la',
    add_pregnancy: 'Adăugați sarcina',
    investigation_status: {
      toDo: 'De făcut',
      inProgress: 'În curs',
      expired: 'Expirat',
      completed: 'Finalizat',
      needToInvestigate: 'Trebuie investigat'
    },
    period_status: {
      initial: 'Initial',
      optional: 'Opțional',
      for28Weeks: 'Pentru 28 de săptămâni',
      for36Weeks: 'Pentru 36 de săptămâni'
    },
    newborn_period_status: {
      atFortyEightHours: 'La 48 de ore',
      atSixToEightWeeks: 'La 6-8 săptămâni',
      atNineMonths: 'La 9 luni'
    },
    newborn_investigations_tabs: {
      status: 'Stare investigații',
      demands: 'Solicitări de investigații'
    },
    newborn_investigation_status: {
      child: 'Copil',
      mother: 'Mamă',
      completeness: 'Completitudine',
      complete: 'Complet',
      incomplete: 'Incomplet',
      missing_count: 'Perioade restante fără rezultat: {{count}}',
      only_incomplete: 'Doar incomplete',
      search_placeholder: 'Caută după copil sau mamă',
      due_date: 'Termen',
      result_date: 'Data rezultatului',
      result: 'Rezultat',
      demand: 'Solicitare',
      states: {
        done: 'Rezultat prezent',
        requested: 'Solicitat – fără rezultat',
        missing: 'Lipsă',
        planned: 'Planificat'
      }
    },
    newborn_plan_result: {
      present: 'Rezultat prezent',
      absent: 'Fără rezultat'
    },
    pregnancy_created_successfully: 'Sarcina a fost adăugată cu succes',
    pregnancy_edit_successfully: 'Sarcina a fost modificată cu succes',
    at_least_one_newborn: 'Trebuie adăugat cel puțin un nou-născut',
    birth_created_successfully: 'Nașterea a fost adăugată cu succes',
    sorting_options: {
      registration_date_asc: 'Data înregistrării (A - Z)',
      registration_date_desc: 'Data înregistrării (Z - A)',
      last_gestation_date_asc: 'Data ultimei menstruații (DUM) (A - Z)',
      last_gestation_date_desc: 'Data ultimei menstruații (DUM) (Z - A)',
      gestational_age_in_weeks_asc: 'Vârsta gestațională (săptămâni) (A - Z)',
      gestational_age_in_weeks_desc: 'Vârsta gestațională (săptămâni) (Z - A)',
      pregnancy_type_asc: 'Tipul sarcinii (A - Z)',
      pregnancy_type_desc: 'Tipul sarcinii (Z - A)',
      expected_date_of_birth_asc: 'Data estimativă a nașterii (DEN) (A - Z)',
      expected_date_of_birth_desc: 'Data estimativă a nașterii (DEN) (Z - A)'
    },
    isPregnancyMonitoring: 'Monitorizare Prenatală',
    isNewborn: 'Nou-născuți'
  },
  sida_notification: {
    title: 'Fișă pentru stabilirea stadiului SIDA',
    add: 'Adaugă fișă SIDA',
    view: 'Vizualizare fișă SIDA',
    patient_identification: 'Date de identificare a pacientului',
    idnp: 'IDNP',
    full_name: 'Nume și Prenume',
    patronymic: 'Patronimicul',
    epidemiology_number: 'Număr epidemiologic',
    birth_date: 'Data nașterii',
    gender: 'Genul',
    current_address: 'Adresa domiciliului curent',
    sida_diagnosis: 'Date specifice diagnosticului SIDA',
    sida_stage_date: 'Data stabilirii stadiului SIDA',
    sida_stage_reason: 'Motivul stabilirii stadiului SIDA',
    sida_reason_indicator_disease:
      'Maladia SIDA indicatoare (infecții oportuniste)',
    sida_reason_cd4: 'Valori scăzute ale markerului CD4',
    sida_reason_both: 'Maladia SIDA indicatoare și valori scăzute CD4',
    arv_treatment_at_diagnosis:
      'Tratament ARV la momentul stabilirii diagnosticului SIDA',
    statistics_report_date: 'Data raportării în statistică a stadiului SIDA',
    medical_personnel: 'Identificarea personalului medical',
    doctor_name: 'Numele și Prenumele medicului',
    doctor_function: 'Funcția medicului',
    save: 'Salvează',
    success_create: 'Fișa SIDA a fost creată cu succes',
    success_update: 'Fișa SIDA a fost actualizată cu succes',
    already_exists: 'Fișa SIDA a fost deja creată pentru acest pacient',
    confirm_save: 'Confirmați salvarea fișei SIDA?',
    yes: 'Da',
    no: 'Nu',
    created_at: 'Data creării',
    male: 'Masculin',
    female: 'Feminin',
    no_case: 'Nu există fișă SIDA pentru acest pacient'
  },
  demographics: {
    yes: 'Da',
    no: 'Nu',
    title: 'Date demografice',
    patronymic: 'Patronimicul',
    maritalStatus: 'Starea civilă',
    vitalStatus: 'Statutul vital',
    deathDate: 'Data decesului',
    deathCause: 'Cauza decesului',
    leftCountryDate: 'Data plecării din țară',
    leftCountry: 'A plecat din țară',
    leftCountryType: 'Tipul plecării',
    arrivedFromAbroadDate: 'Data sosirii din altă țară',
    arrivedFromCountry: 'Țara de proveniență',
    marital_status: {
      married: 'Căsătorit(ă)',
      cohabiting: 'Concubinaj',
      widowed: 'Văduv(ă)',
      single: 'Celibatar(ă)',
      divorced: 'Divorțat(ă)',
      notApplicableChild: 'Nu se aplică (copil)'
    },
    vital_status: {
      alive: 'În viață',
      deceased: 'Decedat(ă)'
    },
    death_cause: {
      aidsRelated: 'Asociată SIDA',
      notAidsRelated: 'Neasociată SIDA',
      unknown: 'Necunoscută'
    },
    left_country_type: {
      temporary: 'Temporar',
      permanent: 'Pentru totdeauna'
    },
    left_country_type_required: 'Alegeți tipul plecării',
    arrived_together:
      'Data sosirii și țara de proveniență se completează împreună',
    arrived_not_home: 'Țara de proveniență nu poate fi Republica Moldova'
  },
  hiv_anamnesis: {
    title: 'Fișa privind anamneza epidemiologică a cazului infecţia cu HIV',
    full_title:
      'Fișa privind anamneza epidemiologică a cazului infecţia cu HIV',
    add: 'Adaugă fișa privind anamneza epidemiologică',
    view: 'Fișa privind anamneza epidemiologică a cazului infecţia cu HIV',
    no_case:
      'Nu există fișa privind anamneza epidemiologică pentru acest pacient',
    draft_hint:
      'Fișa poate fi salvată ca schiță oricând. La finalizare toate câmpurile obligatorii sunt verificate; o fișă finalizată rămâne editabilă, dar fiecare salvare este verificată.',
    save_draft: 'Salvează schiță',
    complete: 'Finalizează',
    save: 'Salvează',
    confirm_draft: 'Salvați fișa ca schiță?',
    confirm_complete: 'Finalizați fișa privind anamneza epidemiologică?',
    confirm_save: 'Salvați modificările fișei privind anamneza epidemiologică?',
    success_draft:
      'Schița fișei privind anamneza epidemiologică a fost salvată',
    success_complete: 'Fișa privind anamneza epidemiologică a fost salvată',
    status_label: 'Statut',
    status: {
      draft: 'Schiță',
      completed: 'Finalizată'
    },
    anonymous_identifier: 'Identificator anonim',
    created_at: 'Data creării',
    updated_at: 'Data modificării',
    completed_at: 'Data finalizării',
    no_personal_data_title: 'Date personale ascunse',
    no_personal_data_description:
      'Nu aveți acces la datele personale ale pacientului. Numele, prenumele, patronimicul și IDNP nu sunt afișate și rămân cele din sistem la salvare.',
    prefilled_from: 'Precompletat din: {{source}}',
    sources: {
      Persons: 'Profilul pacientului',
      CurrentUser: 'Utilizatorul curent',
      Investigations: 'Investigații',
      EpidemiologyCases: 'Fișa 058/e',
      SidaCases: 'Fișa SIDA',
      HivAnamnesisCases: 'Fișa privind anamneza epidemiologică',
      TreatmentPlans: 'Planuri de tratament',
      PregnancyMonitoring: 'Monitorizarea sarcinii',
      Consultations: 'Consultații',
      SimeTb: 'SIME-TB'
    },
    header: {
      title: 'Antet și A. Instituții medicale',
      epidemiology_number: 'Număr epidemiologic',
      epidemiology_number_hint:
        'Generat de SI SBTESP; se completează după sincronizarea cazului 058/e.',
      anonymous_identifier: 'Identificator anonim (cod TESTRAP)'
    },
    institutions: {
      title: 'A. Instituții medicale',
      reporting_institution:
        'Instituția medicală care colectează și raportează anamneza epidemiologică',
      arv_institution:
        'Instituția medicală unde pacientul este luat în evidență și primește TARV',
      doctor_full_name:
        'Numele, prenumele medicului care a colectat și raportat datele',
      collected_at: 'Data colectării datelor'
    },
    patient: {
      title: 'B. Date despre pacient',
      is_anonymous: 'Pacient înregistrat anonim',
      idnp: 'IDNP',
      idnp_format: 'IDNP-ul are 13 cifre și începe cu 2 sau 09',
      last_name: 'Nume',
      first_name: 'Prenume',
      birth_date: 'Data nașterii',
      gender: 'Sex',
      genders: {
        male: 'Masculin',
        female: 'Feminin',
        unknown: 'Altul'
      },
      address: '9. Adresa de domiciliu',
      country: 'Țara',
      locality: 'Raionul / orașul, localitatea',
      street: 'Strada',
      street_number: 'Nr.',
      apartment_number: 'Ap.',
      phone: 'Telefon',
      residence_environment: 'Mediul de reședință',
      residence: {
        urban: 'Urban',
        rural: 'Rural'
      }
    },
    testing: {
      title: 'C. Testarea la HIV și diagnosticul',
      testing_code: 'Cod testare',
      additional_code: 'Cod adițional',
      screening_place: 'Locul testării de screening',
      firstScreening: 'Primul test de screening (A1)',
      secondScreening: 'Al doilea test de screening (A2)',
      confirmation: 'Testul de confirmare (A3)',
      test_type: 'Denumirea testului',
      date: 'Data',
      result: 'Rezultat',
      diagnosis: 'Diagnostic final',
      diagnosis_code: 'Codul diagnosticului final',
      diagnosis_date: 'Data stabilirii diagnosticului'
    },
    test_result: {
      positive: 'Pozitiv',
      negative: 'Negativ',
      indeterminate: 'Indeterminat'
    },
    screening_place: {
      healthCenter: 'Centrul de Sănătate',
      hospital: 'Spital',
      consultativeDepartment: 'Secție consultativă',
      ngo: 'ONG',
      youthFriendlyCenter: 'CPT (Centrul prietenos tinerilor)',
      selfTesting: 'Autotestare',
      penitentiary: 'Penitenciar',
      other: 'Alta'
    },
    transmission: {
      group_30: 'Mama biologică a administrat TARV',
      group_31: 'Copilul dat',
      group_32: 'Mama biologică',
      group_34: 'Mama biologică a avut',
      group_35: 'Copilul înainte de diagnostic a avut (dacă este constatat)',
      title: 'D. Căile de transmitere',
      adult_applies:
        'Pacientul are 15 ani sau mai mult la data colectării: se completează D.1 și D.3.',
      child_applies:
        'Pacientul are sub 15 ani la data colectării: se completează D.2 și D.3.',
      adult_title: 'D.1 Adulți și copii peste 15 ani',
      child_title: 'D.2 Copii sub 15 ani',
      other_title: 'D.3 Transfuzii, expunere profesională, alte riscuri',
      heterosexual_title: 'Contacte heterosexuale',
      heterosexual_required:
        'Calea probabilă (43) este heterosexuală: întrebările 25.1–25.11 sunt obligatorii.',
      mother_heterosexual_title: 'Contacte heterosexuale ale mamei biologice',
      abroad_country: 'Țara partenerului din străinătate',
      first_date: 'Prima dată',
      last_date: 'Ultima dată',
      last_before_first: 'Ultima dată nu poate fi înaintea primei date',
      occupational_institution: 'Instituția',
      occupation: 'Ocupația',
      other_risks_description: 'Descrierea altor riscuri',
      q: {
        sexWithMan: 'Contact sexual cu un bărbat',
        sexWithWoman: 'Contact sexual cu o femeie',
        injectingDrugUse: 'Consum de droguri injectabile',
        nonInjectingDrugUse: 'Consum de droguri neinjectabile',
        motherHivStatusId: 'Statutul HIV al mamei biologice',
        motherTestedDuringPregnancy:
          'Mama a fost testată la HIV în timpul sarcinii / nașterii',
        motherDiagnosisDate: 'Data confirmării diagnosticului HIV al mamei',
        motherSimeCode: 'Numărul SIME HIV al mamei',
        motherArvBeforePregnancy: 'Mama a primit ARV înainte de sarcină',
        motherArvDuringPregnancy: 'Mama a primit ARV în timpul sarcinii',
        motherArvAtBirth: 'Mama a primit ARV la naștere',
        breastfed: 'Copilul a fost alăptat',
        prophylacticArvAfterBirth:
          'Copilul a primit ARV profilactic după naștere',
        motherInjectingDrugUse: 'Mama a consumat droguri injectabile',
        motherPerinatallyInfected: 'Mama a fost infectată cu HIV perinatal',
        motherTransfusion:
          'Mama a avut transfuzii de sânge / produse din sânge',
        motherCoagulationFactors:
          'Mama a primit factori de coagulare / are tulburări de coagulare',
        motherTransplantOrInsemination:
          'Mama a avut transplant de țesuturi / organe sau inseminare artificială',
        childSexWithMan:
          'Copilul, înainte de diagnostic: contact sexual cu un bărbat',
        childSexWithWoman:
          'Copilul, înainte de diagnostic: contact sexual cu o femeie',
        childInjectingDrugUse:
          'Copilul, înainte de diagnostic: droguri injectabile',
        childNonInjectingDrugUse:
          'Copilul, înainte de diagnostic: droguri neinjectabile',
        transfusion: 'Transfuzie de sânge sau produse din sânge',
        coagulationFactors:
          'Recipient de factori de coagulare / tulburări de coagulare',
        transplantOrInsemination:
          'Transplant de țesuturi / organe sau inseminare artificială',
        occupationalExposure: 'Lucrător medical cu expunere profesională',
        otherRisks: 'Alte riscuri',
        possibleNosocomialRoute: 'Posibilă cale nosocomială de infectare',
        cluster: 'Focar cu mai multe cazuri',
        probableRouteId: 'Concluzie: calea probabilă de transmitere'
      },
      heterosexual: {
        withHivInfectedPerson: 'Cu o persoană infectată cu HIV',
        withInjectingDrugUser: 'Cu o persoană care consumă droguri injectabile',
        withBisexualMan: 'Cu un bărbat bisexual',
        withSexWorker: 'Cu un lucrător sexual sau un client al acestuia',
        withHaemophiliac:
          'Cu o persoană cu hemofilie / tulburări de coagulare, infectată cu HIV',
        withBloodRecipient: 'Cu un recipient de sânge infectat cu HIV',
        withMultiplePartners: 'Cu parteneri multipli',
        withCasualPartners: 'Cu parteneri ocazionali',
        withNosocomiallyInfectedPerson: 'Cu o persoană infectată nosocomial',
        withPerinatallyInfectedPerson: 'Cu o persoană infectată perinatal',
        withPersonAbroad: 'Cu o persoană din străinătate'
      }
    },
    family: {
      title: 'E. Date despre familie',
      woman_title: 'Pentru femei',
      children_title: 'Copiii pacientului',
      date: 'Data',
      child_name: 'Numele copilului',
      child_name_hidden: 'Ascuns (date personale)',
      child_birth_date: 'Data nașterii',
      child_tested: 'Testat la HIV',
      child_result: 'Rezultatul',
      add_child: 'Adaugă copil',
      q: {
        spouseInfected: 'Soțul / soția este infectat(ă) cu HIV',
        advisedToDiscloseStatus:
          'Persoana a fost consiliată să-și dezvăluie statutul HIV+ partenerului',
        partnerTested: 'Partenerul sexual a fost testat la HIV',
        gaveBirthBeforeDiagnosis:
          'A născut înainte de confirmarea diagnosticului',
        currentlyPregnant: 'Este însărcinată în prezent',
        pregnantAfterDiagnosis:
          'A fost însărcinată după confirmarea diagnosticului'
      }
    },
    clinical: {
      title: 'F. Date clinice',
      acute_suspected: 'Suspiciune de infecție HIV acută',
      acute_signs: 'Semne / simptome ale sindromului retroviral acut',
      other_evidence: 'Alte dovezi care sugerează infecția acută',
      other_evidence_description: 'Descrierea altor dovezi',
      last_negative_date: 'Data celui mai recent test HIV negativ',
      last_negative_place: 'Locul celui mai recent test HIV negativ',
      viral_load_title: 'Încărcătura virală (ÎV)',
      cd4_title: 'Testul CD4',
      date: 'Data',
      viral_load_first: 'Prima încărcătură virală',
      viral_load_latest: 'Cea mai recentă încărcătură virală',
      copies_per_ml: 'Copii/ml',
      undetectable: 'Nedetectabilă (<40 copii/ml)',
      cd4_first: 'Primul CD4',
      cd4_latest: 'Cel mai recent CD4',
      cd4_count: 'Celule/µl',
      cd4_percent: '%',
      arv_treatment: 'Tratament ARV',
      arv_start_date: 'Data inițierii TARV',
      arv_latest_date: 'Cea mai recentă administrare ARV',
      aids_stage: 'Stadiul SIDA',
      aids_stage_date: 'Data confirmării stadiului SIDA',
      aids_category: 'Categoria clinică SIDA',
      aids_cd4: 'Nivelul CD4 pentru categoria clinică',
      opportunistic_diseases: 'Maladii oportuniste',
      other_diseases: 'Alte maladii (ICD-10)',
      add_other_disease: 'Adaugă altă maladie',
      disease_date: 'Data',
      disease_incomplete: 'Fiecare maladie trebuie aleasă din ICD-10',
      tuberculosis: 'Tuberculoză',
      hepatitisC: 'Hepatită virală C',
      hepatitisB: 'Hepatită virală B',
      receives_treatment: 'Primește tratament',
      treatment_start_date: 'Data inițierii tratamentului',
      first_visit: 'Data primei vizite la medic',
      last_visit: 'Data ultimei vizite la medic',
      last_visit_before_first:
        'Ultima vizită nu poate fi înaintea primei vizite'
    },
    annual_update: {
      record: 'Actualizare anuală ECDC',
      title: 'Actualizarea anuală a datelor clinice (ECDC)',
      hint: 'Secțiunea F și câmpurile ** din afara ei (3.1, 12, 13, 47.3), completate cu datele noi din sistem. Verificați valorile; la salvare devin datele anului ales și noile valori ale fișei (12 și 13 și pe profilul pacientului).',
      year: 'Anul',
      replaces_year:
        'Există deja o actualizare pentru acest an; va fi înlocuită.',
      save: 'Salvează actualizarea',
      success: 'Actualizarea anuală a fost salvată',
      history: 'Istoricul actualizărilor anuale',
      other_fields: 'Câmpuri ** din afara secțiunii F (3.1, 12, 13, 47.3)',
      recorded_at: 'Înregistrat la'
    },
    refresh: {
      button: 'Preia din sistem',
      confirm: 'Preluați datele din sistem pentru această secțiune?',
      description:
        'Se completează valorile pe care sistemul le are acum (ex. rezultate noi); valorile introduse rămân acolo unde sistemul nu are date.',
      success: 'Datele din sistem au fost preluate',
      partial:
        'O parte din datele din sistem nu au putut fi preluate: {{sections}}. Completați-le manual.',
      error: 'Datele din sistem nu au putut fi preluate. Încercați din nou.'
    },
    prefill_warning: {
      failed_title: 'Datele din sistem nu au putut fi preluate',
      failed_description:
        'Completați fișa manual sau încercați mai târziu cu „Preia din sistem” în fiecare secțiune.',
      partial_title: 'Unele date din sistem nu au putut fi preluate',
      partial_description:
        'Verificați și completați manual secțiunile: {{sections}}. Puteți încerca din nou cu „Preia din sistem”.'
    },
    tri_state: {
      yes: 'Da',
      no: 'Nu',
      unknown: '?'
    }
  },
  epidemiology: {
    epidemiology_case: 'Caz epidemiologic',
    epidemiology_and_sida: 'Cazuri epidemiologice și SIDA',
    add_epidemiology_case: 'Adaugă caz epidemiologic',
    no_institution_access_title: 'Acces limitat la instituție',
    no_institution_access_description:
      'Nu aveți acces la datele instituției dumneavoastră. Nu puteți adăuga acest formular. Vă rugăm să contactați administratorul.',
    notification: 'Notificare',
    epidemiology_number: 'Număr epidemiologic',
    institution_that_notified: 'Instituția care a notificat',
    city: 'Raionul / orașul',
    person_who_notified: 'Numele persoanei care a notificat',
    notification_date_time: 'Data / ora notificării',
    primary_diagnostic: 'Diagnostic primar notificat',
    diagnoses_title: 'Diagnosticul și codul diagnosticului conform CIM rev.X',
    diagnostic_date_time: 'Data / ora stabilirii diagnosticului',
    date_time_of_disease_onset: 'Data / ora debutului bolii',
    classification_level: 'Nivelul de clasificare a cazului',
    patient_information: 'Datele de identificare a pacientului',
    registration_title: 'Înregistrarea cazului în sistemul informațional',
    institution_that_registered: 'Instituția care a înregistrat cazul',
    date_time_registration: 'Data / ora înregistrării',
    person_who_registered: 'Persoana care a înregistrat cazul',
    updated_date: 'Data actualizării',
    final_diagnostic: 'Diagnostic final',
    final_diagnostic_institution:
      'Denumirea instituției care a stabilit diagnosticul final',
    final_diagnostic_date: 'Data stabilirii',
    disease_progress: 'Forma evoluției bolii',
    disease_outcome: 'Finalul bolii',
    disease_outcome_date: 'Data finalului bolii',
    death_date: 'Data decesului',
    symptoms_title:
      'Simptome / manifestari ale bolii (pp. 1-9 se completează doar în cazuri neclare, severe și pentru infecții cu program de eliminare)',
    patient_card_title: 'Date de identificare a pacientului',
    patient_status: {
      title: 'Statut de identitate a pacientului',
      identified: 'Identificat',
      anonymous: 'Anonim',
      unidentified: 'Neidentificat'
    },
    work_place: 'Locul de muncă / instruire',
    work_function: 'Funcția',
    last_present_date: 'Data ultimei prezențe',
    street_number: 'Casa / bloc',
    apartment_number: 'Apartament',
    patient_institution:
      'Denumirea instituției de asistență medicală primară în care bolnavul se află la evidență',
    patient_institution_address: 'Adresa instituției de evidență a bolnavului',
    general: 'Generale',
    unknown: 'Necunoscut',
    skin_and_mucous: 'Cutanate și ale mucoaselor',
    neurological: 'Neurologice',
    ocular: 'Oculare',
    respiratory: 'Respiratorii',
    gastro_intestinal: 'Gastro-intestinale',
    urinary_disorders: 'Disfuncții urinare',
    pains: 'Dureri',
    other: 'Alte manifestări',
    hospitalization: 'Spitalizat',
    vaccine: 'Pentru infecții prevenibile prin vaccinare',
    case: 'Cazul este izolat sau de izbucnire',
    save: 'Salvează',
    success_create: 'Cazul a fost creat cu succes',
    search_placeholder: 'Căutare după № epidemiologic, data, etc.',
    status: {
      draft: 'Draft',
      new: 'Nou',
      synchronised: 'Sincronizat'
    },
    sbtesp_code: 'Cod SBTESP',
    synchronised_at: 'Data confirmării',
    created_at: 'Data adăugării în sistem',
    new_cases: 'În sistem au fost adăugate {{count}} cazuri noi',
    new_case: 'În sistem a fost adăugat un caz nou',
    case_description:
      ' Un pacient nou cu ID-ul {{simeCode}} a fost găsit în localitatea {{location}}, cu sex {{gender}} ({{age}} ani).',
    symptoms: {
      general: {
        dontKnow: 'Nu se știe',
        doesntKnow: 'Nu se știe',
        yes: 'Da',
        no: 'Nu',
        unknown: 'Nu se știe',
        yesAccordingToSchedule: 'Da, conform schemei',
        yesWithViolations: 'Da, cu încălcarea schemei/incomplet',
        fever: 'Febră',
        frisoane: 'Frisoane',
        pronouncedWeakness: 'Slăbiciune pronunțată',
        seriousCondition: 'Stare gravă',
        coma: 'Comă',
        persistentCrying: 'Plâns persistent'
      },
      appearanceDate: 'Data apariției',
      skinAndMucous: {
        rashes: 'Erupții cutanate',
        maculoPapular: 'Maculo-papulare',
        microPapular: 'Micro-papulare',
        vesicles: 'Vezicule',
        hemoragic: 'Hemoragice',
        petehii: 'Peteșii',
        eritem: 'Eritem',
        pustule: 'Pustule',
        carbuncul: 'Carbuncul',
        sancru: 'Șancru',
        icter: 'Icter',
        injuries: 'Leziuni',
        animalBite: 'Mușcătură de animal',
        arthropodBite: 'Înțepătură de artropod'
      },
      neurological: {
        consciousnessDisorders: 'Tulburări de conștiință',
        meningealSigns: 'Semne meningeale',
        convulsionsInvoluntaryMovements: 'Convulsii / mișcări involuntare',
        hydrophobia: 'Hidrofobie',
        palsiesParalysis: 'Pareze / paralizii',
        acute: 'Acute',
        flaccid: 'Flasce',
        spastic: 'Spastice',
        limbParalysis: 'Paralizia membrelor',
        facialParalysis: 'Paralizie facială',
        trunkParalysis: 'Paralizia trunchiului',
        symmetric: 'Simetrice',
        asymmetric: 'Asimetrice',
        muscleContractures: 'Contracturi musculare',
        trism: 'Trism',
        neckRigidity: 'Rigiditatea cefei',
        trunkMuscles: 'Mușchii trunchiului',
        limbMuscles: 'Mușchii membrelor'
      },
      ocular: {
        conjunctivitis: 'Conjunctivită',
        photophobia: 'Fotofobie',
        diplopia: 'Diplopie',
        conjunctivalCongestion: 'Congestie conjunctivală'
      },
      respiratory: {
        rhinitis: 'Rinită',
        nasalHemorrhage: 'Hemoragie nazală',
        pharyngitisLaryngitis: 'Faringită / laringită',
        aerophobia: 'Aerofobie',
        cough: 'Tuse',
        oneToTwoWeeks: '1-2 săptămâni',
        moreThanTwoWeeks: 'Mai mult de 2 săptămâni',
        paroxysmal: 'Paroxistică',
        mucopurulent: 'Mucopurulentă',
        bloodySputum: 'Spută cu sânge',
        tonsillitis: 'Amigdalită',
        membranous: 'Membranoasă',
        cataral: 'Catarală',
        purulent: 'Purulentă',
        necrotic: 'Necrotică'
      },
      gastroIntestinal: {
        lossOfAppetite: 'Pierderea poftei de mâncare',
        nausea: 'Greață',
        swallowingDifficulties: 'Dificultăți la înghițire',
        bloodInStool: 'Sânge în scaun',
        acolicStool: 'Scaun acolic',
        tenesmus: 'Tenesme',
        vomiting: 'Vomă',
        diarrhea: 'Diaree',
        dehydration: 'Deshidratare'
      },
      urinaryDisorders: {
        oliguriaAnuria: 'Oligurie / anurie',
        hyperchromicUrine: 'Urină hipercromă',
        hematuria: 'Hematurie',
        cloudyUrine: 'Urină tulbure',
        frequentMicturition: 'Micțiuni frecvente'
      },
      pains: {
        headache: 'Cefalee',
        jointPain: 'Dureri articulare',
        musclePain: 'Dureri musculare',
        abdominalPain: 'Dureri abdominale',
        rightHypochondriumPain: 'Hipocondrul drept',
        epigastricPain: 'Epigastru'
      },
      other: {
        lymphNodeSwelling: 'Tumefierea ganglionilor limfatici',
        occipitalLymphNodes: 'Ganglioni occipitali',
        submandibularLymphNodes: 'Ganglioni submandibulari',
        axillaryLymphNodes: 'Ganglioni axilari',
        salivaryGlandSwelling: 'Tumefierea glandelor salivare',
        otherSymptom: 'Altele'
      },
      hospitalization: {
        title: 'Denumirea instituției',
        hospitalizationDate: 'Data spitalizării'
      },
      vaccine: {
        patientVaccinated: 'Pacientul a fost vaccinat?',
        numberOfDoses: 'Numărul de doze',
        lastDoseDate: 'Data ultimei doze'
      },
      caseType: {
        singleCase: 'Caz izolat',
        outbreakCase: 'Caz de izbucnire'
      }
    },
    per_day: 'ori pe zi',
    severity: 'gradul',
    access_requests:
      'Aveți {{count}} solicitări noi de acces la date personale de către epidemiolog',
    access_request:
      'Aveți o nouă solicitare de acces la date personale de către epidemiolog',
    access_request_description:
      'Solicitare de acces la date personale pentru pacientul {{lastName}} {{firstName}} cu codul sime {{simeCode}}',
    success_accept_request: 'Solicitarea a fost acceptată cu succes',
    success_refuse_request: 'Solicitarea a fost refuzată cu succes',
    refuse_reason: 'Motivul refuzului',
    access_requests_title: 'Solicitări date personale',
    confirm_access_request:
      'Confirmă accesul la datele personale a pacientului ?',
    refuse_access_request: 'Refuză accesul la datele personale a pacientului ?',
    residential_address: 'Reședință oficială',
    address: 'Domiciliu de facto',
    institution_classification:
      'Clasificarea instituției conform serviciilor prestate',
    residence_environment: 'Mediul de reședință'
  },
  transfer: {
    title: 'Transferul pacientului',
    from_institution: 'Din Instituția Medicală',
    to_institution: 'Către Instituția Medicală',
    start_date_from: 'Inițiere de la',
    start_date_to: 'Inițiere de la',
    end_date_from: 'Finalizare de la',
    end_date_to: 'Finalizare de la',
    start_date_asc: 'Data de inițiere (A - Z)',
    start_date_desc: 'Data de inițiere (Z - A)',
    end_date_asc: 'Data de finalizare (A - Z)',
    end_date_desc: 'Data de finalizare (Z - A)',
    start_date: 'Data de inițiere',
    end_date: 'Data de finalizare',
    transfer: 'Transfer',
    new: 'Nou',
    pending: 'In asteptare',
    rejected: 'Respins',
    accepted: 'Acceptat',
    transferred: 'Transferat',
    search_placeholder: 'Căutare după IDNP, Cod SIM, Nume, Prenume, etc',
    created_at_asc: 'Data de creare (A - Z)',
    created_at_desc: 'Data de creare (Z - A)',
    sime_code_asc: 'Cod SIM (A - Z)',
    sime_code_desc: 'Cod SIM (Z - A)',
    tarv_code_asc: 'Cod TARV (A - Z)',
    tarv_code_desc: 'Cod TARV (Z - A)',
    gender_asc: 'Gen (A - Z)',
    gender_desc: 'Gen (Z - A)',
    reject: 'Refuzați',
    reject_transfer: 'Refuzați transfer',
    approve_transfer: 'Aprobați transferul',
    take_data_from_mconnnect: 'Preluati date prin MConnect',
    search_in_mconnect: 'Căutare în Mconnect',
    transfer_approved: 'Transfer aprobat',
    verified_data_mconnect: 'Date verificate prin MConnect',
    get_data_from_mconnect: 'Preluare date din MConnect',
    transfer_type: 'Tipul transferului',
    permanent: 'Permanent',
    temporary: 'Temporar'
  },
  funding_source: {
    delete: 'Ștergeți sursa de finanțare?',
    create: 'Creați sursa de finanțare',
    create_success: 'Sursa de finanțare creată cu succes'
  },
  active_substances: {
    prefix: 'Prefix',
    create_substance: 'Adăugați substanță activă',
    create_substance_success: 'Substanța activă a fost adăugată cu succes',
    delete_substance_title: 'Ștergeți substanța activă?'
  },
  consultation_form: {
    primary_title: 'Fișa privind Examenul Primar la Adult și Adolescent',
    secondary_title: 'Fișa privind Examenul Repetat la Adult și Adolescent',
    covered_diseases: 'Afecţiunile şi maladiile suportate',
    surgeries_in_anamnesis: 'Intervenţii chirurgicale în anamneză',
    its_in_anamnesis: 'ITS în anamneză',
    syphilis: 'Sifilis',
    no_specification: 'Nespecificată',
    vaccines: 'Vaccinări',
    national_calendar: 'Calendar național de vaccinare',
    vaccines_other: 'alte vaccinuri, de specificat',
    type: {
      primary: 'Primară',
      secondary: 'Secundară'
    },
    allergies: {
      allergies: 'Alergii',
      medicine_allergies: 'medicamentoase, de specificat',
      medicines: 'Alergii medicamentoase',
      food: 'Alergii alimentare',
      other: 'Alți alergeni',
      food_allergies: 'alimentare, de specificat',
      other_allergies: 'alți alergeni, de specificat'
    },
    body_constitution_changes: {
      title: 'Schimbări în constituţia corporală',
      weightGain: 'creștere în greutate',
      weightLoss: 'scădere în greutate',
      noChanges: 'fără schimbări'
    },
    current_medication: 'Medicaţiile curente',
    to_specify: 'de specificat',
    family_medical_anamnesis: {
      title: 'Anamneza medicală familială',
      diabetesMellitus: 'diabet zaharat',
      skinLesions: 'leziuni cutanate',
      hypertension: 'hipertensiune arterială',
      malignantFormations: 'formațiuni maligne etc.'
    },
    tb_patients_contacts:
      'Contacte cu pacienţii cu TB (ale pacientului sau ale membrilor familiei lui)',
    substance_consumption: {
      title: 'Consumul de substanţe:',
      drugs: 'Droguri (în trecut şi în prezent)',
      smoking: 'Fumat',
      alcohol: 'Alcool'
    },
    reproductive_and_sexual_health: {
      title: 'Sănătatea reproducerii şi sexuală',
      yes: 'Da',
      no: 'Nu',
      contraception: 'Contracepție'
    },
    pregnancy: {
      title: 'Sarcină',
      previous_pregnancy: 'Precedente',
      current_pregnancy: 'Curentă',
      previous: 'Precedente, de specificat câte și rezultatul',
      current: 'Curentă, de specificat termenul',
      planned: 'Planificate'
    },
    social_anamnesis: {
      title: 'Anamneza socială',
      studies: {
        title: 'Studii',
        highEducation: 'Superioare',
        primaryEducation: 'Primare',
        mediumEducation: 'Medii',
        noEducation: 'Fără studii'
      },
      employment_and_occupation: 'Angajarea în câmpul muncii şi ocupaţia'
    },
    anamnesis_section: 'ANAMNEZA',
    physical_examination_section: 'EXAMENUL FIZIC',
    accusations: 'Acuze',
    general_state: {
      title: 'Starea generală',
      satisfactory: 'Satisfăcătoare',
      mediumGravity: 'De gravitate medie',
      grave: 'Gravă',
      extremelyGrave: 'Extrem de gravă'
    },
    conscience: {
      title: 'Conștiința',
      clear: 'Clară',
      confused: 'Confuză',
      coma: 'Comă',
      delirium: 'Delir'
    },
    position: {
      title: 'Poziția',
      active: 'Activă',
      passive: 'Pasivă',
      forced: 'Forțată'
    },
    constitutional_type: {
      title: 'Tipul constituțional',
      astenic: 'Astenic',
      normostenic: 'Normostenic',
      hyperstenic: 'Hiperstenic'
    },
    vital_physiological_indices: 'Indicii fiziologici vitali',
    pulse: 'Pulsul',
    temperature: 'Temperatura',
    hypertension: 'Tensiunea arterială',
    breathing_frequency: 'Frecvența respiraţiei',
    peripheral_lymph_nodes: {
      title: 'Nodulii limfatici periferici',
      enlarged: 'Măriți, de specificat care grup',
      notEnlarged: 'Nu sunt măriți',
      details: {
        enlarged: 'Măriți',
        notEnlarged: 'Nu sunt măriți'
      }
    },
    cutaneous_teguments: {
      title: 'Tegumentele cutanate',
      activeSignsOfShingles: 'Semne active de zona zoster',
      vascularStars: 'Steluțe vasculare',
      placesToInjectDrugs: 'Locuri de injectare a drogurilor',
      postSignsOfShingles: 'Semne post de zona zoster',
      seborrheicDermatitis: 'Dermatită seboreică',
      otherModifications: 'Alte modificări, de specificat'
    },
    oropharynx: {
      title: 'Orofaringe',
      noModification: 'Fără modificări',
      villousLeukoplakiaOfTheOralCavity:
        'Leucoplachia viloasă a cavităţii bucale',
      modification: 'Cu modificări, de specificat',
      candidalStomatitis: 'Stomatita candidozică',
      primarySyphilis: 'Sifilis primar'
    },
    chest_and_lungs: {
      title: 'Torace şi plămâni',
      chest_form: 'Forma toracelui',
      symmetric: 'Simetrică',
      asymmetric: 'Asimetrică',
      auscultatory: 'Auscultativ',
      rales: 'Raluri',
      vesicular_sounds: 'Murmurul vezicular',
      wet: 'Umede',
      dry: 'Uscate',
      mixed: 'Mixte',
      diminishing: 'Diminuat',
      normal: 'Obișnuit',
      attenuated: 'Atenuat'
    },
    cardiac_exam: {
      title: 'Examenul cardiac',
      auscultatory_cardiac_exam: 'Auscultativ',
      noModifications: 'fără modificări',
      heartMurmurs: 'sufluri',
      arrhythmia: 'aritmie, de specificat',
      otherModifications: 'alte modificări'
    },
    abdominal_gastrointestinal_assessment: {
      title: 'Examenul abdominal şi al sistemului gastrointestinal',
      liver: 'Ficatul',
      isPalpable: 'Se palpează',
      isNotPalpable: 'Nu se palpează',
      isPainful: 'Dureros',
      isNotPainful: 'Nedureros',
      consistency: 'Consistența',
      soft: 'Moale',
      elastic: 'Elastică',
      hard: 'Dură',
      spleen: 'Splina',
      intestinalMotility: 'Motilitatea intestinală',
      present: 'Prezența peristalticei intestinale',
      absent: 'Lipsa peristalticei intestinale',
      abdominalSensitivity: 'Sensibilitatea abdomenului la palpare',
      isSensitive: 'Sensibil',
      isInsensitive: 'Insensibil',
      hasMuscleRigidity: 'Rigiditatea mușchilor  abdominali',
      digestiveSigns: 'Semne digestive',
      hasNausea: 'Nausea',
      hasVomiting: 'Voma',
      hasDysphagia: 'Disfagia'
    },
    genital: {
      title: 'Examenul regiunii genitale şi anale:',
      hasHerpesSimplex: 'Herpes simplex',
      hasPrimarySyphilis: 'Sifilis primar',
      hasCondylomas: 'Condiloame acuminate',
      hasOtherPathologies: 'Alte patologii, de specificat'
    },
    neuorological: {
      title: 'Starea neurologică',
      meningeal_signs: 'Semne meningiene',
      isPositive: 'Pozitive,  de specificat',
      isNegative: 'Negativ'
    },
    visual_functions: {
      title: 'Funcţiile vizuale'
    },
    isAffected: 'Afectate, de specificat',
    affected: 'Afectate',
    isNotAffected: 'Păstrate',
    auditive_functions: {
      title: 'Funcţiile auditive'
    },
    urinary: {
      title: 'Sistemul urinar',
      urination: 'Micțiunea',
      isFree: 'Liberă',
      isPainful: 'Dureroasă',
      isDifficult: 'Cu dificultăți',
      isNotPainful: 'Nedureroasă',
      tapping_symptom: 'Simptomul de taponament',
      isPositiveBilateral: 'Pozitiv bilateral',
      isNegativeBilateral: 'Negativ bilateral',
      isPositiveUnilateral: 'Pozitiv unilateral, de specificat',
      positiveUnilateral: 'Pozitiv unilateral',
      defecation: 'Particularitățile de defecare',
      hasConstipation: 'Constipație',
      hasNoPeculiarities: 'Fără particularități',
      hasDiarrhea: 'Diareie',
      fecal: 'Caracterul maselor fecale',
      isSemiLiquid: 'Semilichid',
      isLiquid: 'Lichid',
      isFormed: 'Oformat',
      isNormal: 'Obișniut',
      hasBloodStreaks: 'Cu striuri de sînge',
      hasMucus: 'Cu mucus',
      hasPus: 'Cu puroi'
    }
  },
  cron: {
    schedule: 'Program',
    select_schedule: 'Selectați programul',
    every_text: 'fiecare',
    empty_months: 'fiecare lună',
    empty_month_days: 'fiecare zi a lunii',
    empty_month_days_short: 'zi a lunii',
    empty_week_days: 'fiecare zi a săptămânii',
    empty_week_days_short: 'zi a săptămânii',
    empty_hours: 'fiecare oră',
    empty_minutes: 'fiecare minut',
    empty_minutes_for_hour_period: 'fiecare',
    year_option: 'an',
    month_option: 'lună',
    week_option: 'săptămână',
    day_option: 'zi',
    hour_option: 'oră',
    minute_option: 'minut',
    reboot_option: 'repornire',
    prefix_period: 'Fiecare',
    prefix_months: 'în',
    prefix_month_days: 'în',
    prefix_week_days: 'în',
    prefix_week_days_for_month_and_year_period: 'și',
    prefix_hours: 'la',
    prefix_minutes: ':',
    prefix_minutes_for_hour_period: 'la',
    suffix_minutes_for_hour_period: 'minut(e)',
    error_invalid_cron: 'Expresie cron invalidă',
    clear_button_text: 'Șterge',
    start_data_administration: 'Data început administrare',
    end_data_administration: 'Data finalizare administrare'
  },
  equipments: {
    search_placeholder: 'Căutare echipament',
    add_new_equipment: 'Adăugați un echipament nou',
    code: 'Cod unic',
    add_new_device: 'Adăugați un dispozitiv nou',
    device_search_placeholder: 'Căutare dispozitiv',
    inspection_period: 'Perioda de inspectare',
    add_device: 'Adăugați dispozitiv',
    edit_device: 'Editează dispozitivul',
    create_success_device: 'Dispozitivul a fost creat cu succes',
    edit_success_device: 'Dispozitivul a fost modificat cu succes',
    delete_device: 'Ștergeți dispozitivul?',
    delete_success_device: 'Dispozitivul a fost șters cu succes',
    last_inspection_date: 'Data ultimei inspectări',
    device_type: 'Tip dispozitiv',
    create_success_equipment: 'Echipamentul a fost creat cu succes',
    edit_success_equipment: 'Echipamentul a fost modificat cu succes',
    add_equipment: 'Adăugați echipament',
    edit_equipment: 'Editează echipamentul',
    delete_success_equipment: 'Echipamentul a fost șters cu succes',
    delete_equipment: 'Ștergeți echipamentul?',
    equipment: 'Echipament',
    technical_inspections: 'Inspecțiile tehnice',
    add_inspection: 'Adaugă inspecție tehnică',
    examination_date: 'Data examinării',
    success_create_inspection: 'Inspecțiunea a fost adăugată cu succes'
  },
  laboratory_classifiers: {
    value_options: 'Valori / Opțiuni',
    delete_option: 'Șterge această opțiune ?',
    add_option: 'Adaugă opțiune',
    edit_option: 'Editează opțiune',
    delete_success_option: 'Opțiunea a fost ștearsă cu succes',
    create_success_option: 'Opțiunea a fost creată cu succes',
    edit_success_option: 'Opțiunea a fost modificată cu succes',
    reference_intervals: 'Intervale de referință',
    min_value: 'Valoarea minimă',
    max_value: 'Valoarea maximă',
    min_value_error: 'Valoarea minimă nu poate fi mai mare ca valoarea maximă',
    min_max_value_error: 'Specificați cel puțin una din valoari',
    test_types: 'Tipuri de teste',
    result_type: 'Tip rezultat',
    unit_measure: 'Unitate de măsură',
    result_options: 'Opțiuni rezultat',
    value_option_result: 'Valorea / Opțiune rezultat',
    reference_interval_result: 'Interval de referință',
    add_test_type: 'Adaugă tip test',
    is_tb: 'Tip de investigație TB',
    is_rapid_test:
      'Test rapid pentru screening (apare în cererea de screening)',
    edit_test_type: 'Editează tip test',
    delete_success_test_type: 'Tipul testului a fost șters cu succes',
    create_success_test_type: 'Tipul testului a fost creat cu succes',
    edit_success_test_type: 'Tipul testului a fost modificat cu succes',
    delete_test_type: 'Șterge acest tip de test ?',
    investigation_type: 'Tip investigație',
    add_investigation_type: 'Adaugă tip investigație',
    edit_investigation_type: 'Editează tip investigație',
    delete_success_investigation_type:
      'Tip investigație a fost șters cu succes',
    create_success_investigation_type:
      'Tip investigație a fost creat cu succes',
    edit_success_investigation_type:
      'Tip investigație a fost modificat cu succes',
    delete_investigation_type: 'Șterge acest tip de investigație ?',
    investigation_title: 'Denumire investigație',
    investigation_short_title: 'Denumire investigație variantă scurtă',
    investigation_category: 'Categorie investigație',
    investigation_infection: 'Infecție',
    work_method: 'Metoda de lucru',
    work_method_domain: 'Domeniul metodei de lucru',
    specimen_storage: 'Condiții de depozitare a probelor',
    medical_speciality: 'Specialitatea medicală',
    select_institution_categories: 'Selectați categorii la instituția curentă',
    select_other_institution_categories:
      'Selectați categorii de la altă instituție',
    select_institution: 'Selectați o instituție',
    select_category_error: 'Selectați cel puțin o categorie',
    type: {
      all: 'Toate',
      laboratory: 'Laborator',
      screening: 'Screening',
      suportScreening: 'Suport screenig',
      internalLaboratory: 'Laborator intern'
    },
    person: {
      all: 'Toate',
      anonymous: 'Anonime',
      identified: 'Identificate'
    },
    allowed_modules: 'Module admisibile',
    allowed_persons: 'Tipuri de persoane admisibile',
    select_laboratory_institution: 'Selectați instituția laboratorului',
    selected_institution: 'Instituția selectată',
    no_investigations_for_current_institution:
      'Nu există investigații configurate pentru instituția curentă. Selectați altă instituție unde va fi efectuat testul.',
    value_option_type: 'Tip semantic rezultat',
    value_option_type_options: {
      positive: 'Pozitiv',
      negative: 'Negativ',
      others: 'Altele'
    },
    test_type_category: 'Categorie test',
    category: 'Categorie',
    test_type_category_options: {
      a1: 'A1',
      a2: 'A2',
      a3: 'A3',
      other: 'Altele'
    }
  },
  specimens: {
    add_investigation: 'Adaugă eșantion',
    code: 'Cod',
    prefix: 'Prefix',
    type: 'Tip',
    category: 'Categorie',
    created_by: 'Creat de',
    created_at: 'Creat la',
    harvested_by: 'Recoltat de',
    harvested_at: 'Recoltat la',
    received_by: 'Primit de',
    received_at: 'Primit la',
    person: 'Persoană',
    specimen_type: 'Tip probă',
    investigation_added: 'Investigația a fost adăugată cu succes',
    investigations_added: 'Investigațiile au fost adăugate cu succes',
    investigation_add_failed: 'Nu s-a putut adăuga „{{type}}”: {{error}}',
    investigation_test_type: 'Tip investigație',
    investigation_tests: 'Teste investigație',
    result_value: 'Valoare rezultat',
    result_option: 'Opțiune rezultat',
    test_type: 'Tip test'
  },
  localities: {
    raion: 'Raion',
    city: 'Oraş',
    municipalSector: 'Sectorul municipiului',
    municipality: 'Mu­nicipiu',
    localityWithinTheCityOrMunicipality: 'Localitate din componenţa oraşului',
    villageOrCommune: 'Sat/Comună',
    localityWithinTheVillageOrCommune: 'Localitate din componenţa satului'
  },
  medical_assistance: {
    primaryMedicalCare: 'Îngrijire medicală primară',
    hospitalMedicalCare: 'Îngrijire medicală spitalicească',
    emergencyMedicalCare: 'Îngrijire medicală de urgență',
    consultativeMedicalCare: 'Îngrijire medicală consultativă',
    laboratory: 'Laborator',
    others: 'Altele',
    penitentiary: 'Penitenciar'
  },
  risk_groups: {
    add_new_group: 'Adaugă grupă nouă de risc',
    edit_title: 'Editează grupa de risc',
    add_title: 'Adaugă grupă de risc',
    parent_category: 'Categoria părinte',
    for_kids: 'Grup de risc pentru copii',
    success_edit: 'Grupa de risc a fost modificată cu succes',
    success_create: 'Grupa de risc a fost creată cu succes',
    success_delete: 'Grupa de risc a fost ștearsă cu succes',
    delete_title: 'Ștergeți această grupă de risc ?',
    start_date: 'Ziua adăugării',
    end_date: 'Ziua finalizării',
    risk_group: 'Grupul de risc',
    finalize: 'Elimină din grupul de risc',
    success_finalize: 'Persoana a fost eliminată din grupul de risc',
    add_to_group: 'Adaugă la grup de risc',
    success_add: 'Persoana a fost adăugată cu succes la grupul de risc',
    preventive_treatment_recommended: 'Se recomandă tratament preventiv',
    success_remove: 'Grupul de risc a fost șters cu succes',
    exclusion_reason: 'Motivul eliminării',
    removed_at: 'Data eliminării',
    removed_by: 'Eliminat de'
  },
  screening: {
    screening_number: 'Screening №',
    search_placeholder: 'Căutare după № de screening',
    created_by: 'Creat de',
    add_screening: 'Adăugați screening',
    exam_date: 'Data examinării',
    number_value: 'Valoare Numerică',
    isHivSeropositive: 'Este HIV seropozitiv',
    result: 'Rezultat',
    preventive_treatment: 'Recomanda tratament preventiv',
    accept_treatment:
      'Pentru a reduce riscul de infectie, medicul recomanda initierea unui tratament preventiv',
    date: 'Data recomandarii',
    recommendations: 'Recomandări',
    initiated_by: 'Inițiat de',
    add_test: 'Adaugă test',
    remove_test: 'Șterge testul',
    test_number: 'Test {{number}}',
    tested_by: 'Medicul care a efectuat testarea inițială',
    duplicate_test:
      'Acest tip de test a fost deja adăugat pentru această investigație'
  },
  treatment_types_classifier: {
    search_placeholder: 'Căutare după tip tratament',
    treatment_type: 'Tip tratament',
    create_treatment_type: 'Adaugă tip tratament',
    delete_treatment_type_title: 'Ștergeți acest tip de tratament ?',
    create_success_treatment_type: 'Tipul tratamentului a fost creat cu succes',
    edit_success_treatment_type:
      'Tipul tratamentului a fost modificat cu succes',
    delete_success_treatment_type: 'Tipul tratamentului a fost șters cu succes',
    delete_treatment_type: 'Șterge acest tip de tratament ?'
  },
  templates: {
    create_treatment_template: 'Creează șablon de tratament',
    treatment_templates: 'Șablone de tratament'
  },
  cuatm: {
    add_cuatm: 'Adăugați element CUATM',
    delete_success: 'Elementul CUATM a fost șters cu succes',
    delete_title: 'Ștergeți acest element CUATM ?',
    edit_title: 'Editează element CUATM',
    parent: 'Element părinte',
    statistic_code: 'Cod statistic',
    abbreviation: 'Abreviere',
    create_success: 'Elementul CUATM a fost creat cu succes',
    edit_success: 'Elementul CUATM a fost modificat cu succes'
  },
  charts: {
    months: 'Luni',
    cd4_cells_per_micro_liter: 'CD4 celule/μL'
  },
  screening_tb: {
    title: 'Screening TB',
    sime_code: 'Cod SIME',
    status: 'Status',
    transmitted: 'Transmis la TB',
    not_transmitted: 'Netransmis',
    tab_all: 'Toate',
    tab_transmitted: 'Transmise',
    tab_not_transmitted: 'Netransmise',
    tb_institution: 'Instituție TB',
    tb_doctor: 'Medic TB',
    not_assigned: 'Neasignat'
  }
}

export default ro
